import type { Locale } from "../domain/types";

const ru = {
  "app.title": "Квартал граней",
  "loading.title": "Открываем квартал…",
  "loading.kingdom": "Открываем королевство…",
  "loading.diamond": "Пробуждаем бриллиант…",
  "loading.workshop": "Зажигаем мастерскую…",
  "loading.trophies": "Готовим Зал трофеев…",
  "loading.arena": "Открываем Арену…",
  "loading.retry": "Повторить",
  "common.soon": "скоро",
  "common.and": "и",
  "currency.name": "Караты",
  "currency.short": "карат",
  "header.profile": "Открыть профиль",
  "header.season": "До конца сезона",
  "header.seasonStarts": "До начала сезона",
  "header.claimCloses": "До закрытия получения награды",
  "header.balance": "Караты",
  "header.seasonShort": "Сезон",
  "header.seasonFund": "Фонд сезона",
  "header.estimateNow": "сейчас",
  "header.estimatePending": "до оценки",
  "header.estimatePendingValue": "{time}",
  "header.estimatedReward": "Текущая оценка награды",
  "header.balanceDetails": "Открыть баланс карат",
  "header.passiveTitle": "Добыча",
  "header.passive": "+{value}",
  "header.noPassive": "0/с",
  "header.inGame": "В игре {value}",
  "nav.label": "Основные разделы",
  "nav.core": "Бриллиант",
  "nav.development": "Мастерская",
  "nav.progress": "Зал трофеев",
  "nav.friends": "Клуб мастеров",
  "nav.games": "Арена",
  "map.world": "Карта мира",
  "map.title": "Квартал граней",
  "map.open": "Открыть Квартал граней",
  "map.home": "Вернуться к бриллианту",
  "map.diamond": "Бриллиант",
  "map.development": "Мастерская",
  "map.developmentHint": "Улучшения",
  "map.progress": "Зал трофеев",
  "map.progressHint": "Цели и сезон",
  "map.friends": "Клуб мастеров",
  "map.friendsHint": "Друзья",
  "map.games": "Арена",
  "map.gamesHint": "Матчи",
  "map.openDevelopment": "Открыть Мастерскую",
  "map.openProgress": "Открыть Зал трофеев",
  "map.openFriends": "Открыть Клуб мастеров",
  "map.openGames": "Открыть Арену",
  "map.back": "Карта",
  "map.backA11y": "Вернуться на карту",
  "core.tapHint": "Нажми на бриллиант",
  "core.tapButton": "Огранить бриллиант",
  "core.tapArea": "Огранить бриллиант, награда {value}",
  "core.nextUpgrade": "Запустить резец · {cost}",
  "core.needMore": "Нужно ещё {value}",
  "core.cutterWorking": "Механический резец · +{value}",
  "core.openDevelopment": "Открыть развитие",
  "core.seasonScheduled": "Мастерская ждёт начала сезона",
  "core.seasonFrozen": "Мастерская остановлена до расчёта",
  "core.rewardReady": "Сезонная награда готова",
  "core.rewardReceived": "Награда сезона получена",
  "development.title": "Мастерская огранки",
  "development.stage": "Бриллиант · ступень {stage}",
  "development.nextStage": "Следующая ступень меняет оправу и свечение бриллианта",
  "development.faceting": "Огранка",
  "development.mechanisms": "Механизмы",
  "development.manualTool": "Ручная огранка",
  "development.manualLevel": "Уровень 1",
  "development.manualCurrent": "Сейчас: +{value} за тап",
  "development.manualNext": "Следующий эффект откроется после первого привода",
  "development.cutter": "Контур огранки",
  "development.level": "Уровень {level}",
  "development.currentIdle": "Сейчас: 0/с",
  "development.currentActive": "Сейчас: +{value}",
  "development.nextActive": "После улучшения: +{value}",
  "development.installed": "Контур работает",
  "development.upgrade": "Улучшить за {cost}",
  "development.details": "Подробнее о контуре",
  "development.sheetTitle": "Контур огранки",
  "development.sheetBody": "Энергетическая оправа накапливает караты между тапами",
  "development.sheetCurrent": "Текущая выработка",
  "development.sheetAfter": "После запуска",
  "development.sheetVisual": "У бриллианта появятся бирюзовая оправа, медный пояс и световой центр",
  "development.notEnough": "Нужно ещё {value}",
  "development.returnCore": "Вернуться к бриллианту",
  "progress.title": "Зал трофеев",
  "progress.today": "Сегодня",
  "progress.achievements": "Зал славы",
  "progress.season": "Сезон",
  "progress.taskTaps": "Сделайте {target} тапов",
  "progress.taskPassive": "Получите {target} от мастерской",
  "progress.taskValue": "{current}/{target}",
  "progress.completed": "Выполнено",
  "progress.daySummary": "Цели обновляются с подтверждённым прогрессом",
  "progress.achievementTitle": "Живая грань",
  "progress.achievementBody": "Запустите контур огранки",
  "progress.achievementReady": "Знак готов",
  "progress.achievementClaim": "Получить знак",
  "progress.achievementClaimed": "Знак получен",
  "progress.ranking": "Рядом в рейтинге",
  "progress.you": "Вы",
  "progress.place": "№ {place}",
  "progress.pool": "Пул сезона",
  "progress.estimate": "Оценочная стоимость: {value}",
  "progress.estimateNote": "Оценка может измениться до снимка остатка",
  "progress.snapshotRule": "В итог войдут караты на балансе в момент сезонного снимка",
  "progress.activeSeasonTitle": "Сезон идёт",
  "progress.activeSeasonBody": "До завершения — {time}",
  "progress.seasonScheduledTitle": "Сезон скоро начнётся",
  "progress.seasonScheduledBody": "Старт — {date}",
  "progress.seasonFrozenTitle": "Сезон завершён",
  "progress.seasonFrozenBody": "Подводим итоги. Награда появится после расчёта",
  "progress.seasonSettlingTitle": "Подводим итоги",
  "progress.seasonSettlingBody": "Баланс зафиксирован, расчёт уже идёт",
  "progress.rewardReadyTitle": "Награда готова",
  "progress.rewardReadyBody": "Оценочная стоимость — {value}",
  "progress.rewardClaim": "Получить награду",
  "progress.rewardClaimStars": "Получить за {stars} ⭐",
  "progress.rewardClaimedTitle": "Награда получена",
  "progress.rewardClaimedBody": "Эквивалент сохранён на счёте Diamond Kingdom",
  "progress.rewardExpiredTitle": "Время истекло",
  "progress.rewardExpiredBody": "Окно получения этой награды закрылось",
  "friends.title": "Клуб мастеров",
  "friends.lead": "Развивайтесь вместе",
  "friends.body": "Получайте часть валюты, которую активные друзья производят сами",
  "friends.invite": "Пригласить друга",
  "friends.lineOne": "Друзья",
  "friends.lineTwo": "Друзья друзей",
  "friends.contribution": "Произведено {value}",
  "friends.total": "Команда произвела {value}",
  "friends.emptyTitle": "Команда пока пуста",
  "friends.emptyBody": "Пригласите друга — после первого входа он появится в клубе",
  "friends.shareTitle": "Diamond Kingdom",
  "friends.shareText": "Присоединяйся к моему Клубу мастеров",
  "friends.copied": "Ссылка для приглашения скопирована",
  "games.title": "Арена",
  "games.catalogKicker": "Игровой зал",
  "games.catalogTitle": "Выберите испытание",
  "games.catalogBody": "Каждая игра проверяет своё мастерство и использует общий баланс карат",
  "games.catalogOpen": "Открыто",
  "games.catalogSoon": "Скоро",
  "games.catalogEnter": "Открыть игру",
  "games.catalogBack": "Все игры",
  "games.catalogPenaltyTag": "Точность против реакции",
  "games.catalogResonance": "Резонансный рывок",
  "games.catalogResonanceBody": "Удерживайте импульс в меняющемся кристальном контуре",
  "games.catalogRelic": "Дуэль реликвий",
  "games.catalogRelicBody": "Распределите пять импульсов между реликвиями и наберите больше очков",
  "games.catalogRelicTag": "Пять реликвий · пять решений",
  "games.catalogComingSoon": "Испытание откроется в одном из следующих обновлений",
  "games.relicKicker": "Испытание разума",
  "games.relicTitle": "Дуэль реликвий",
  "games.relicSubtitle": "Каждая реликвия имеет цену. Решите, где потратить самый сильный импульс",
  "games.relicChooseTable": "Выберите стол",
  "games.relicTableHint": "В тесте ставка задаёт уровень дуэли, но не списывается",
  "games.relicPreviewNotice": "Тренировочная дуэль · караты не списываются",
  "games.relicPreviewBadge": "Тест",
  "games.relicBackShort": "Игры",
  "games.relicOpponent": "Страж",
  "games.relicYou": "Вы",
  "games.relicVersus": "VS",
  "games.relicRound": "Раунд",
  "games.relicRoundPot": "На кону",
  "games.relicChooseImpulse": "Выберите импульс",
  "games.relicImpulseHint": "Каждую силу можно применить только один раз",
  "games.relicLocked": "Выбор сделан",
  "games.relicAutoMove": "Время вышло · ход выбран",
  "games.relicPlayerRoundWin": "Реликвия ваша",
  "games.relicOpponentRoundWin": "Реликвия у Стража",
  "games.relicTieRound": "Равные импульсы.",
  "games.relicCarryPot": "Следующий банк",
  "games.relicResultWin": "Дуэль выиграна",
  "games.relicResultLoss": "Страж победил",
  "games.relicResultDraw": "Равновесие граней",
  "games.relicResultWinBody": "Вы точнее распределили силу между реликвиями",
  "games.relicResultLossBody": "Попробуйте сохранить сильный импульс для дорогой реликвии",
  "games.relicResultDrawBody": "Силы равны. Другой порядок импульсов изменит исход",
  "games.relicPlayAgain": "Повторить дуэль",
  "games.relicChooseAnotherTable": "Выбрать другой стол",
  "games.relicStrength": "сила",
  "games.relicCanvasLabel": "Дуэль реликвий. Выберите стол, затем импульс от одного до пяти в каждом раунде",
  "games.available": "Свободно",
  "games.reserved": "В матчах",
  "games.stake": "Ваша ставка",
  "games.playFor": "Играть на {value}",
  "games.penalty": "Хрустальный пенальти",
  "games.penaltyBody": "Три серии ударов и сейвов. Лучший счёт забирает общий банк",
  "games.rules": "Правила игры",
  "games.bank": "Банк матча",
  "games.eachStake": "Вы и соперник вносите по {value}",
  "games.searchTitle": "Ищем соперника",
  "games.searchBody": "Страж Арены вступит в матч через {seconds}",
  "games.searching": "Поиск идёт",
  "games.loadingArena": "Загружаем арену",
  "games.loadingScene": "Расставляем игроков",
  "games.loadingCount": "{loaded} из {total} объектов",
  "games.cancel": "Отменить поиск",
  "games.guardianChoice": "Сразиться со Стражем",
  "games.guardianChoiceBody": "Начать матч сейчас, не дожидаясь соперника",
  "games.found": "Соперник найден",
  "games.guardianReady": "Соперник готов к матчу",
  "games.zonePrompt": "Выберите направление",
  "games.savePrompt": "Выберите прыжок",
  "games.zoneLabel": "Зона {zone}",
  "games.shotZone": "Ударить: {zone}",
  "games.saveZone": "Прыгнуть: {zone}",
  "games.zone.1": "Влево",
  "games.zone.2": "По центру",
  "games.zone.3": "Вправо",
  "games.zone.4": "Левый нижний угол",
  "games.zone.5": "Правый нижний угол",
  "games.roleShot": "Ваш удар",
  "games.roleSave": "Вы в воротах",
  "games.moveAccepted": "Направление выбрано",
  "games.waitOpponent": "Ждём соперника",
  "games.autoMove": "Время вышло — система выбрала зону",
  "games.turnTime": "На выбор",
  "games.series": "Серия {current} из {total}",
  "games.suddenDeath": "Решающая серия {current}",
  "games.scoreYou": "Вы",
  "games.scoreOpponent": "Страж",
  "games.goal": "Гол",
  "games.save": "Сейв",
  "games.attemptsYou": "Ваши удары",
  "games.attemptsOpponent": "Удары соперника",
  "games.attemptGoal": "Гол",
  "games.attemptSave": "Удар отбит",
  "games.calloutYouScored": "Вы забили",
  "games.calloutOpponentSaved": "Соперник отбил",
  "games.calloutYouSaved": "Вы отбили",
  "games.calloutYouConceded": "Вы пропустили",
  "games.resultWin": "Победа на Арене",
  "games.resultLoss": "Соперник сильнее",
  "games.resultDraw": "Равный счёт",
  "games.resultCancelled": "Поиск отменён",
  "games.resultWinBody": "Ваша ставка вернулась вместе с выигрышем",
  "games.resultLossBody": "Ставка перешла победителю",
  "games.resultDrawBody": "Ваша ставка полностью возвращена",
  "games.resultCancelledBody": "Ваша ставка возвращена",
  "games.matchBank": "Банк: {value}",
  "games.resultPayout": "Вы получили {value}",
  "games.resultRefund": "Ставка возвращена: {value}",
  "games.yourZone": "Ваш выбор: зона {zone}",
  "games.opponentZone": "Выбор соперника: зона {zone}",
  "games.playAgain": "Сыграть ещё",
  "games.returnArena": "Вернуться на Арену",
  "games.notEnough": "Не хватает {value} для этой ставки",
  "games.syncRestored": "Матч обновлён",
  "games.syncRestoredBody": "Показываем актуальное состояние. Продолжите игру",
  "games.leaveTitle": "Выйти из матча?",
  "games.leaveBody": "Матч останется активным. Вернуться к нему можно на Арене",
  "games.leave": "Перейти в раздел",
  "games.stay": "Остаться в игре",
  "profile.title": "Профиль",
  "profile.name": "Мастер Алекс",
  "profile.subtitle": "Огранщик сезона",
  "profile.music": "Музыка",
  "profile.effects": "Эффекты",
  "profile.vibration": "Вибрация",
  "profile.reducedMotion": "Меньше движения",
  "profile.language": "Язык",
  "profile.russian": "Русский",
  "profile.english": "English",
  "profile.settingsHint": "Настройки сохраняются на этом устройстве",
  "profile.reset": "Сбросить демо-состояние",
  "profile.close": "Закрыть профиль",
  "sheet.close": "Закрыть",
  "balance.title": "Баланс",
  "balance.available": "На балансе",
  "balance.reserved": "В резерве",
  "balance.production": "Выработка",
  "balance.unitPerSecond": "{value}",
  "balance.kicker": "Сезонная казна",
  "balance.hero": "Караты",
  "balance.availableNow": "Караты на балансе",
  "balance.estimateLabel": "Оценка в USDT",
  "balance.estimateIfNow": "Если бы сезон завершился сейчас",
  "balance.estimatePreparing": "Оценка формируется",
  "balance.estimateRevealsIn": "Откроется через {time}",
  "balance.estimateWarmupBody": "Караты уже участвуют в сезоне. В первые дни сумма в USDT скрыта, пока распределение между игроками не станет показательным.",
  "balance.estimateWarmupNote": "Это не влияет на итог: в сезонный снимок войдёт остаток карат на вашем балансе.",
  "balance.fund": "Призовой фонд сезона",
  "balance.caratBody": "Караты — игровая валюта Квартала. В конце сезона значение на вашем балансе определяет долю в призовом фонде.",
  "balance.caratSources": "Получайте их за огранку, работу мастерской и награды.",
  "balance.rewardTitle": "Как считается награда",
  "balance.rewardStepFund": "Фонд сезона устанавливается заранее.",
  "balance.rewardStepBalance": "При завершении сезона фиксируются остатки карат всех игроков.",
  "balance.rewardStepShare": "Фонд распределяется пропорционально этим остаткам: больше доля карат — больше доля фонда.",
  "balance.estimateChanges": "Оценка может вырасти или снизиться. Итог зависит от вашей активности и балансов других игроков.",
  "balance.exact": "Точное значение",
  "balance.tapYield": "За тап",
  "balance.seasonRule": "В конце сезона учитывается остаток карат на балансе. Потраченные на усиления караты в распределении не участвуют, а незавершённые матчи сначала будут рассчитаны.",
  "workshop.kicker": "Дом производства",
  "workshop.lead": "Усиливайте тап и пассивное производство",
  "workshop.balance": "Баланс",
  "workshop.power": "Мощность",
  "workshop.stageProgress": "Ступень {stage} из 4",
  "workshop.stage.1": "Ручная огранка",
  "workshop.stage.2": "Живой контур",
  "workshop.stage.3": "Призматический привод",
  "workshop.stage.4": "Кинетическое ателье",
  "workshop.appearance": "Облик мастерской",
  "workshop.appearanceA11y": "Облик {stage}: {name}",
  "workshop.mastery": "{level} из {total} усилений",
  "workshop.appearanceStepsOne": "Ещё {count} усиление до нового облика",
  "workshop.appearanceStepsFew": "Ещё {count} усиления до нового облика",
  "workshop.appearanceStepsMany": "Ещё {count} усилений до нового облика",
  "workshop.appearanceComplete": "Все облики открыты",
  "workshop.upgradesTitle": "Усиления",
  "workshop.consoleTitle": "Выберите направление",
  "workshop.consoleLead": "Развивайте добычу, силу тапа и запас энергии",
  "workshop.masteryA11y": "Прогресс развития мастерской",
  "workshop.precision.name": "Резонансный резец",
  "workshop.precision.body": "Усиливает каждый тап",
  "workshop.mechanical.name": "Контур огранки",
  "workshop.mechanical.body": "Производит караты без тапов",
  "workshop.current": "Сейчас",
  "workshop.next": "Станет",
  "workshop.branchLevel": "Уровень {level} из {max}",
  "workshop.levelRoute": "Прогресс уровня",
  "workshop.max": "Ветка освоена в этом сезоне",
  "workshop.coreLevels": "Основное развитие — до уровня {level}",
  "workshop.masterLevels": "Высшее мастерство · за караты",
  "workshop.launchMechanicalAction": "Запустить контур",
  "workshop.upgradeMechanicalAction": "Усилить контур",
  "workshop.upgradePrecisionAction": "Усилить резец",
  "workshop.detailsFor": "Подробнее: {name}",
  "workshop.shortfall": "Нужно ещё {value}",
  "workshop.tapEffect": "+{value} за тап",
  "workshop.passiveEffect": "+{value}",
  "workshop.unitPerTap": "карат за тап",
  "workshop.unitPerSecond": "карат/с",
  "workshop.effectComparisonA11y": "Сейчас {current}, после усиления {next}",
  "workshop.appearanceWillChange": "После усиления мастерская изменит облик",
  "workshop.productionSpeed": "Скорость добычи",
  "workshop.tapStrength": "Сила тапа",
  "workshop.sheetCost": "Цена",
  "workshop.sheetGainTap": "Прирост за тап",
  "workshop.sheetGainPassive": "Прирост скорости",
  "workshop.precision.sheet": "Резец направляет свет на грани и усиливает каждый подтверждённый тап",
  "workshop.mechanical.sheet": "Контур добывает караты, пока мастерская работает без ваших тапов",
  "energy.kicker": "Энергетический контур",
  "energy.title": "Запас для огранки",
  "energy.lead": "Энергия расходуется только на тапы и возвращается со временем",
  "energy.reserve": "Энергия",
  "energy.runtimeLabel": "Кристальный накопитель",
  "energy.open": "Открыть запас энергии",
  "energy.full": "Полный заряд",
  "energy.fullBody": "Накопитель готов к огранке",
  "energy.empty": "Запас исчерпан",
  "energy.synchronizing": "Сохраняем тапы…",
  "energy.next": "+1 через {seconds} с",
  "energy.level": "Уровень {level} из {max}",
  "energy.capacityName": "Кристальный накопитель",
  "energy.capacityBody": "Увеличивает запас энергии",
  "energy.capacityUnit": "энергии",
  "energy.capacityValue": "{value} энергии",
  "energy.recoveryName": "Поток восстановления",
  "energy.recoveryBody": "Повышает скорость восстановления",
  "energy.recoveryUnit": "энергии/с",
  "energy.recoveryRateValue": "{value} энергии в секунду",
  "energy.secondsValue": "1 за {value} с",
  "energy.changeA11y": "Сейчас {current}, после усиления {next}",
  "energy.max": "Максимальный уровень",
  "energy.upgradeAction": "Усилить",
  "energy.upgradeCapacityAction": "Усилить накопитель",
  "energy.upgradeRecoveryAction": "Ускорить поток",
  "energy.refillsLeft": "Быстрых зарядов: {count}",
  "energy.sheetTitle": "Восстановить энергию",
  "energy.sheetLead": "Накопитель сразу получит {value} энергии",
  "energy.recoveryRate": "Восстановление",
  "energy.refillAmount": "Будет добавлено",
  "energy.today": "Осталось сегодня",
  "energy.refillAction": "Зарядить сейчас",
  "energy.limitTitle": "Заряды на сегодня закончились",
  "energy.limitBody": "Энергия продолжит восстанавливаться сама",
  "hall.kicker": "Коллекция сезона",
  "hall.lead": "Цели сегодня, трофеи навсегда",
  "hall.dailySeal": "Печать дня",
  "hall.goalsDone": "{current} из 3 целей",
  "hall.dailyReward": "Награда дня",
  "hall.claimDaily": "Забрать {value}",
  "hall.dailyClaimed": "Награда получена",
  "status.rewardAlreadyClaimed": "Эта награда уже получена",
  "hall.taskTaps": "Точная рука",
  "hall.taskTapsBody": "Сделайте {target} тапов",
  "hall.taskPrimary": "Сила смены",
  "hall.taskPrimaryBody": "Получите {target} карат огранкой и мастерской",
  "hall.taskPassive": "Сердце мастерской",
  "hall.taskPassiveBody": "Получите {target} карат от мастерской",
  "hall.dailyKicker": "Три испытания",
  "hall.dailyTitle": "Маршрут мастера",
  "hall.dailyLead": "Выполните все три испытания и вручную раскройте Печать дня",
  "hall.untilReset": "До обновления",
  "hall.resetClock": "{hours} ч {minutes} мин",
  "hall.resetSoon": "Совсем скоро",
  "hall.trialNumber": "Испытание {number}",
  "hall.dailyForced": "для всех",
  "hall.dailyPriority": "важно сегодня",
  "hall.openChannel": "Открыть канал",
  "hall.openChat": "Открыть чат",
  "hall.checkMembership": "Проверить",
  "hall.daily.tap-light-touch.name": "Лёгкая огранка",
  "hall.daily.tap-light-touch.body": "Сделайте {target} подтверждённых тапов",
  "hall.daily.tap-steady-hand.name": "Верный ритм",
  "hall.daily.tap-steady-hand.body": "Сделайте {target} подтверждённых тапов",
  "hall.daily.tap-precision.name": "Точная рука",
  "hall.daily.tap-precision.body": "Сделайте {target} подтверждённых тапов",
  "hall.daily.tap-clear-facet.name": "Чистая грань",
  "hall.daily.tap-clear-facet.body": "Сделайте {target} подтверждённых тапов",
  "hall.daily.tap-master-tempo.name": "Темп мастера",
  "hall.daily.tap-master-tempo.body": "Сделайте {target} подтверждённых тапов",
  "hall.daily.tap-long-cut.name": "Большая огранка",
  "hall.daily.tap-long-cut.body": "Сделайте {target} подтверждённых тапов",
  "hall.daily.tap-royal-shift.name": "Королевская огранка",
  "hall.daily.tap-royal-shift.body": "Сделайте {target} тапов",
  "hall.daily.energy-royal-cycle.name": "Заряд королевства",
  "hall.daily.energy-royal-cycle.body": "Потратьте {target} энергии на огранку",
  "hall.daily.primary-royal-order.name": "Королевский заказ",
  "hall.daily.primary-royal-order.body": "Добудьте {target} карат огранкой и мастерской",
  "hall.daily.primary-grand-caravan.name": "Большой запас",
  "hall.daily.primary-grand-caravan.body": "Добудьте {target} карат огранкой и мастерской",
  "hall.daily.passive-royal-stream.name": "Поток королевства",
  "hall.daily.passive-royal-stream.body": "Соберите {target} карат пассивной добычи",
  "hall.daily.passive-grand-reserve.name": "Сокровища мастерской",
  "hall.daily.passive-grand-reserve.body": "Соберите {target} карат пассивной добычи",
  "hall.daily.arena-royal-series.name": "Королевская серия",
  "hall.daily.arena-royal-series.body": "Сыграйте {target} матчей на арене — с игроком или стражем",
  "hall.daily.arena-double-victory.name": "Двойная победа",
  "hall.daily.arena-double-victory.body": "Выиграйте {target} матчей на арене — у игрока или стража",
  "hall.daily.energy-deep-cut.name": "Глубокая огранка",
  "hall.daily.energy-deep-cut.body": "Потратьте {target} энергии на огранку",
  "hall.daily.energy-full-cycle.name": "Полный заряд",
  "hall.daily.energy-full-cycle.body": "Потратьте {target} энергии на огранку",
  "hall.daily.primary-first-shift.name": "Первая смена",
  "hall.daily.primary-first-shift.body": "Добудьте {target} карат огранкой и мастерской",
  "hall.daily.primary-bright-shift.name": "Яркая смена",
  "hall.daily.primary-bright-shift.body": "Добудьте {target} карат огранкой и мастерской",
  "hall.daily.primary-full-shift.name": "Полная смена",
  "hall.daily.primary-full-shift.body": "Добудьте {target} карат огранкой и мастерской",
  "hall.daily.primary-strong-shift.name": "Сильная смена",
  "hall.daily.primary-strong-shift.body": "Добудьте {target} карат огранкой и мастерской",
  "hall.daily.primary-master-shift.name": "Смена мастера",
  "hall.daily.primary-master-shift.body": "Добудьте {target} карат огранкой и мастерской",
  "hall.daily.primary-grand-order.name": "Большой заказ",
  "hall.daily.primary-grand-order.body": "Добудьте {target} карат огранкой и мастерской",
  "hall.daily.passive-quiet-current.name": "Тихий ток",
  "hall.daily.passive-quiet-current.body": "Получите {target} карат от механизмов",
  "hall.daily.passive-crystal-pulse.name": "Кристальный пульс",
  "hall.daily.passive-crystal-pulse.body": "Получите {target} карат от механизмов",
  "hall.daily.passive-light-stream.name": "Поток света",
  "hall.daily.passive-light-stream.body": "Получите {target} карат от механизмов",
  "hall.daily.passive-engine-room.name": "Машинный зал",
  "hall.daily.passive-engine-room.body": "Получите {target} карат от механизмов",
  "hall.daily.passive-full-vault.name": "Полное хранилище",
  "hall.daily.passive-full-vault.body": "Получите {target} карат от механизмов",
  "hall.daily.passive-cascade.name": "Каскад карат",
  "hall.daily.passive-cascade.body": "Получите {target} карат от механизмов",
  "hall.daily.offline-return.name": "Возвращение мастера",
  "hall.daily.offline-return.body": "Заберите добычу мастерской после перерыва",
  "hall.daily.offline-vault.name": "Два сбора",
  "hall.daily.offline-vault.body": "Дважды заберите добычу мастерской после перерыва",
  "hall.daily.return-second-session.name": "Снова в королевстве",
  "hall.daily.return-second-session.body": "Проведите {minutes} мин. вне игры, затем вернитесь. Новый вход начинает отсчёт заново",
  "hall.daily.arena-first-duel.name": "Первый поединок",
  "hall.daily.arena-first-duel.body": "Завершите {target} матч на Арене",
  "hall.daily.arena-double-duel.name": "Три поединка",
  "hall.daily.arena-double-duel.body": "Завершите {target} матча на Арене",
  "hall.daily.arena-first-win.name": "Победа на Арене",
  "hall.daily.arena-first-win.body": "Выиграйте {target} матч на Арене",
  "hall.daily.arena-match-series.name": "Два поединка",
  "hall.daily.arena-match-series.body": "Завершите {target} матча на Арене",
  "hall.daily.upgrade-workshop.name": "Новый механизм",
  "hall.daily.upgrade-workshop.body": "Улучшите мастерскую {target} раз",
  "hall.daily.upgrade-workshop-double.name": "Двойное усиление",
  "hall.daily.upgrade-workshop-double.body": "Улучшите мастерскую {target} раза",
  "hall.daily.venture-tap-echo.name": "Эхо огранки",
  "hall.daily.venture-tap-echo.body": "Сделайте ещё {target} подтверждённых тапов",
  "hall.daily.venture-primary-spark.name": "Искра квартала",
  "hall.daily.venture-primary-spark.body": "Добудьте {target} карат любым способом",
  "hall.daily.invite-master.name": "Новый мастер",
  "hall.daily.invite-master.body": "Пригласите {target} нового участника",
  "hall.daily.join-channel.name": "Вестник квартала",
  "hall.daily.join-channel.body": "Подпишитесь на канал, чтобы завершить маршрут",
  "hall.daily.join-chat.name": "Совет мастеров",
  "hall.daily.join-chat.body": "Вступите в чат, чтобы завершить маршрут",
  "hall.daily.generic.name": "Задание дня",
  "hall.seasonTask.generic.name": "Задача сезона",
  "hall.task.metric.confirmed-taps": "Сделайте {target} подтверждённых тапов",
  "hall.task.metric.primary-produced": "Добудьте {target} карат любым способом",
  "hall.task.metric.passive-produced": "Получите {target} карат от механизмов",
  "hall.task.metric.energy-spent": "Потратьте {target} энергии на огранку",
  "hall.task.metric.offline-collections": "Заберите добычу мастерской {target} раз",
  "hall.task.metric.return-visits": "Вернитесь в игру {target} раз после перерыва",
  "hall.task.metric.upgrade-purchases": "Купите {target} улучшений. Бесплатный стартовый уровень не считается покупкой",
  "hall.task.metric.arena-matches": "Завершите {target} матчей",
  "hall.task.metric.arena-wins": "Выиграйте {target} матчей на Арене",
  "hall.task.metric.pvp-matches": "Завершите {target} матчей на Арене — с игроками или Стражем",
  "hall.task.metric.daily-routes-claimed": "Заберите общую награду дня в {target} разных игровых днях. Не обязательно подряд",
  "hall.task.metric.active-invites": "Пригласите {target} активных мастеров",
  "hall.task.metric.confirmed-invites": "Пригласите {target} новых участников",
  "hall.task.metric.channel-membership": "Оставайтесь подписаны на канал сообщества",
  "hall.task.metric.chat-membership": "Оставайтесь в чате сообщества",
  "hall.streakTitle": "Серия маршрутов",
  "hall.streakDays": "{count} дней подряд",
  "hall.streakNext": "На {day}-й день бонус — {value}",
  "hall.streakComplete": "Все награды серии раскрыты",
  "hall.streakKicker": "Награды за постоянство",
  "hall.streakSheetLead": "Забирайте награду дня без пропусков: каждый следующий день приносит больше карат.",
  "hall.streakNextReward": "Награда за {day}-й день",
  "hall.streakCalendarA11y": "Календарь наград серии на 30 дней",
  "hall.streakMilestoneA11y": "Дополнительный бонус",
  "hall.streakRuleTitle": "Награду нужно забрать вовремя",
  "hall.streakRuleBody": " Если пропустить день или не нажать «Забрать», серия начнётся заново.",
  "hall.streakContinue": "Продолжить маршрут",
  "hall.portalTodayMeta": "{current} из 3 выполнено",
  "hall.portalCollectionMeta": "{count} в коллекции",
  "hall.portalSeasonMeta": "Рейтинг и фонд",
  "hall.portalDailyReady": "Награда дня готова",
  "hall.portalAchievementsReady": "Знаков готово: {count}",
  "hall.portalSeasonReady": "Награда сезона готова",
  "hall.portalReadyBadge": "Готовых наград: {count}",
  "hall.rewardStored": "Караты уже добавлены в ваш баланс",
  "hall.rewardReady": "Печать раскрыта — награду можно получить",
  "hall.rewardRemaining": "Осталось выполнить: {count}",
  "hall.rewardNextTasks": "Осталось: {tasks}",
  "hall.showRemainingTask": "К невыполненному заданию",
  "hall.progressValue": "{current} из {target}",
  "hall.filterAll": "Все",
  "hall.filterCraft": "Огранка",
  "hall.filterSeason": "Сезон",
  "hall.filterFriends": "Клуб",
  "hall.categoryCraft": "Мастерство",
  "hall.categorySeason": "Сезонный путь",
  "hall.categoryFriends": "Клуб мастеров",
  "hall.vaultKicker": "Коллекционные знаки",
  "hall.vaultTitle": "Коллекция мастера",
  "hall.collectionCount": "{current} из {total} в коллекции",
  "hall.achievement.first-spark.name": "Первая искра",
  "hall.achievement.first-spark.body": "Сделайте 10 подтверждённых тапов",
  "hall.achievement.living-facet.name": "Живая грань",
  "hall.achievement.living-facet.body": "Улучшите Контур огранки до 2-го уровня",
  "hall.achievement.master-rhythm.name": "Ритм мастера",
  "hall.achievement.master-rhythm.body": "Сделайте 100 подтверждённых тапов",
  "hall.achievement.light-architect.name": "Архитектор света",
  "hall.achievement.light-architect.body": "Достигните 3-й ступени мастерской",
  "hall.achievement.makers-circle.name": "Круг мастеров",
  "hall.achievement.makers-circle.body": "Соберите команду из 3 мастеров",
  "hall.achievement.perfect-facet.name": "Совершенная грань",
  "hall.achievement.perfect-facet.body": "Улучшите Резонансный резец до 5-го уровня",
  "hall.achievement.crystal-reserve.name": "Кристальный запас",
  "hall.achievement.crystal-reserve.body": "Улучшите Кристальный накопитель до 3-го уровня",
  "hall.achievement.silent-current.name": "Тихий поток",
  "hall.achievement.silent-current.body": "Добудьте 100 000 карат пассивно",
  "hall.achievement.arena-guardian.name": "Страж Арены",
  "hall.achievement.arena-guardian.body": "Одержите 10 побед на Арене",
  "hall.achievement.season-one-participant.name": "Первый сезон",
  "hall.achievement.season-one-participant.body": "Сделайте хотя бы один подтверждённый тап в первом сезоне",
  "hall.achievement.season-two-participant.name": "Дороги королевства",
  "hall.achievement.season-two-participant.body": "Знак участника второго сезона. Вручается после завершения сезона за хотя бы один тап.",
  "hall.achievement.streak-seven.name": "Неделя света",
  "hall.achievement.streak-seven.body": "Забирайте награду дня 7 дней подряд",
  "hall.achievement.streak-fifteen.name": "Несломанная грань",
  "hall.achievement.streak-fifteen.body": "Забирайте награду дня 15 дней подряд",
  "hall.achievement.streak-thirty.name": "Хроника мастерства",
  "hall.achievement.streak-thirty.body": "Пройдите дневной маршрут все 30 дней сезона без пропусков",
  "hall.achievement.chain-conqueror.name": "Покоритель путей",
  "hall.achievement.chain-conqueror.body": "Завершите все 6 основных цепочек сезонных испытаний",
  "hall.achievement.branch-master.name": "Вершина ремесла",
  "hall.achievement.branch-master.body": "Завершите основное развитие одной ветви мастерской",
  "hall.achievement.workshop-sovereign.name": "Владыка мастерской",
  "hall.achievement.workshop-sovereign.body": "Завершите основное развитие всех 4 ветвей. Дополнительные уровни не нужны",
  "hall.achievement.pvp-first-win.name": "Первая дуэль",
  "hall.achievement.pvp-first-win.body": "Одержите первую победу на Арене — над игроком или Стражем",
  "hall.achievement.pvp-ten-wins.name": "Гроза Арены",
  "hall.achievement.pvp-ten-wins.body": "Одержите 10 побед на Арене — над игроками или Стражем",
  "hall.achievement.arena-ten-matches.name": "Десять поединков",
  "hall.achievement.arena-ten-matches.body": "Завершите 10 матчей на Арене",
  "hall.achievement.arena-fifty-matches.name": "Легенда Арены",
  "hall.achievement.arena-fifty-matches.body": "Завершите 50 матчей на Арене",
  "hall.achievement.active-friend-one.name": "Первый союз",
  "hall.achievement.active-friend-one.body": "Пригласите лично одного мастера. Он засчитается после {threshold} добычи за сезон",
  "hall.achievement.active-friend-three.name": "Тройственный союз",
  "hall.achievement.active-friend-three.body": "Пригласите лично 3 мастеров. Каждый должен добыть {threshold} за сезон",
  "hall.achievement.active-friend-ten.name": "Совет мастеров",
  "hall.achievement.active-friend-ten.body": "Пригласите лично 10 мастеров. Каждый должен добыть {threshold} за сезон",
  "hall.achievement.top-ten-percent.name": "Высшая лига",
  "hall.achievement.top-ten-percent.body": "Завершите сезон среди 10% сильнейших игроков",
  "hall.achievement.top-hundred.name": "Сотня сильнейших",
  "hall.achievement.top-hundred.body": "Завершите сезон в первой сотне рейтинга",
  "hall.achievement.top-ten.name": "Десятка королевства",
  "hall.achievement.top-ten.body": "Завершите сезон в первой десятке рейтинга",
  "hall.achievement.season-champion.name": "Корона сезона",
  "hall.achievement.season-champion.body": "Займите первое место по итогам сезона",
  "hall.finalRankPending": "Откроется после итогов сезона",
  "hall.rankProgress": "Место {current} · цель: топ-{target}",
  "hall.percentileProgress": "Сейчас топ-{current}% · цель: топ-{target}%",
  "hall.ready": "Можно получить",
  "hall.claimed": "В коллекции",
  "hall.claim": "Получить знак",
  "hall.collectibleLocked": "Ещё не получено",
  "hall.collectibleShopStatus": "Доступен в лавке",
  "hall.collectibleOpenShop": "Открыть лавку",
  "hall.collectibleOpenShopA11y": "Открыть облики в лавке: {name}",
  "hall.collectibleSeasonZeroStatus": "После завершения сезона",
  "hall.collectibleSeasonZeroBody": "Сделайте хотя бы один подтверждённый тап. Знак появится после завершения Сезона 0.",
  "hall.claimTask": "Забрать",
  "hall.taskReward": "Награда",
  "hall.finalCheck": "Проверим в финале",
  "hall.seasonBalance": "Ваш остаток",
  "hall.seasonPlace": "Место сейчас",
  "hall.seasonShare": "Ваша доля",
  "hall.seasonEstimate": "Оценка награды",
  "hall.seasonEstimateNote": "Оценка меняется вместе с остатками игроков",
  "hall.projectionPreparingKicker": "Казна набирает ритм",
  "hall.projectionPreparing": "Оценка откроется через {time}",
  "hall.projectionPreparingBody": "Караты уже учитываются. Место, доля фонда и сумма в USDT появятся, когда первые результаты сезона станут показательными.",
  "hall.distributionIn": "До распределения",
  "hall.seasonStartsIn": "До начала сезона",
  "hall.claimClosesIn": "До закрытия получения награды",
  "hall.countdownDays": "дн.",
  "hall.countdownHours": "ч.",
  "hall.countdownMinutes": "мин.",
  "hall.prizeFund": "Призовой фонд",
  "hall.prizeFundNote": "Фонд текущего сезона",
  "hall.tonPrize.kicker": "Призы лидерам",
  "hall.tonPrize.title": "500 USDT на кошельки",
  "hall.tonPrize.body": "Игроки на местах с 1-го по 6-е получат настоящие USDT в сети TON сверх сезонной награды.",
  "hall.tonPrize.network": "Выплата в сети TON",
  "hall.tonPrize.place": "№ {place}",
  "hall.tonPrize.details": "Как получить",
  "hall.tonPrize.rule": "Места фиксируются по балансу карат в финальном снимке.",
  "hall.tonPrize.sheetKicker": "Отдельный призовой пул",
  "hall.tonPrize.sheetTitle": "500 USDT для лидеров",
  "hall.tonPrize.sheetBody": "Это реальные USDT в сети TON. Они не зачисляются на внутренний счёт наград Diamond Kingdom.",
  "hall.tonPrize.stepFinal": "После завершения сезона сервер зафиксирует итоговые места.",
  "hall.tonPrize.stepWallet": "Победитель подтвердит свой TON-кошелёк и запросит выплату.",
  "hall.tonPrize.stepPayout": "Проект отправит USDT на подтверждённый адрес. Stars и комиссия с победителя не списываются.",
  "hall.tonPrize.tieRule": "При равном балансе сумма занятых призовых мест делится между игроками поровну.",
  "hall.tonPrize.winnerKicker": "Ваш приз лидера",
  "hall.tonPrize.winnerTitle": "Вы заняли место № {place}",
  "hall.tonPrize.winnerAmount": "К выплате — {value}",
  "hall.tonPrize.locked": "Итоги зафиксированы. Выплата откроется после проверки рейтинга.",
  "hall.tonPrize.walletRequired": "Чтобы получить приз, подтвердите TON-кошелёк. Кнопка появится после проверки итогов.",
  "hall.tonPrize.ready": "Кошелёк подтверждён. Можно запросить выплату.",
  "hall.tonPrize.processing": "Перевод отправляется в сеть TON.",
  "hall.tonPrize.paid": "USDT отправлены на ваш TON-кошелёк.",
  "hall.tonPrize.expired": "Срок получения приза завершён.",
  "hall.tonPrize.failed": "Перевод не завершён. Повторная отправка будет доступна после проверки.",
  "hall.ofParticipants": "из {count} участников",
  "hall.shareOfFund": "от текущего фонда",
  "hall.rankingKicker": "Ближайшие соперники",
  "hall.seasonScheduledHint": "Корона зажжётся в момент старта",
  "hall.seasonActiveHint": "Караты на балансе определяют ваше место",
  "hall.seasonFrozenHint": "Остатки зафиксированы, идёт расчёт",
  "hall.seasonSettlingHint": "Проверяем финальные условия и готовим распределение",
  "hall.seasonClaimHint": "До закрытия — {window}. Получение стоит {stars} Stars. Награда сохранится на счёте наград в профиле. Это расчётная стоимость игровых токенов, не перевод USDT на кошелёк.",
  "hall.seasonClosedHint": "Результат сохранён в истории профиля",
  "hall.seasonExpiredHint": "Награда сгорела: её нужно было получить за {window}",
  "hall.seasonQuestsKicker": "Большой путь",
  "hall.seasonQuestsTitle": "Задачи сезона",
  "hall.seasonQuestsProgress": "Получено {current} из {total}",
  "hall.communityKicker": "Финальное условие",
  "hall.communityTitle": "Союз королевства",
  "hall.communityBody": "Оставайтесь в канале и чате до завершения сезона. После финальной проверки к вашему остатку добавится 50%.",
  "hall.communityBonusRate": "+50% к остатку",
  "hall.communityBonusPreview": "+{value} к текущему остатку",
  "hall.communityBonusApplied": "Добавлено {value}",
  "hall.communityReady": "Канал и чат подтверждены",
  "hall.communityMissing": "Нужно присоединиться: {targets}",
  "hall.communityFinalCheck": "Подписку повторно проверим в момент завершения сезона",
  "hall.communityChannelShort": "канал",
  "hall.communityChatShort": "чат",
  "hall.seasonTask.season-taps-1.name": "Проба ритма",
  "hall.seasonTask.season-taps-1.body": "Сделайте {target} подтверждённых тапов",
  "hall.seasonTask.season-taps-2.name": "Уверенный ритм",
  "hall.seasonTask.season-taps-2.body": "Сделайте {target} подтверждённых тапов",
  "hall.seasonTask.season-taps-3.name": "Ритм королевства",
  "hall.seasonTask.season-taps-3.body": "Сделайте {target} подтверждённых тапов",
  "hall.seasonTask.season-primary-1.name": "Первая казна",
  "hall.seasonTask.season-primary-1.body": "Добудьте {target} карат за сезон",
  "hall.seasonTask.season-primary-2.name": "Большая огранка",
  "hall.seasonTask.season-primary-2.body": "Добудьте {target} карат за сезон",
  "hall.seasonTask.season-primary-3.name": "Королевский запас",
  "hall.seasonTask.season-primary-3.body": "Добудьте {target} карат за сезон",
  "hall.seasonTask.season-upgrades-1.name": "Устройство мастерской",
  "hall.seasonTask.season-upgrades-1.body": "Купите {target} улучшения. Бесплатный стартовый уровень не считается покупкой",
  "hall.seasonTask.season-upgrades-2.name": "Архитектор света",
  "hall.seasonTask.season-upgrades-2.body": "Купите {target} улучшений. Бесплатный стартовый уровень не считается покупкой",
  "hall.seasonTask.season-upgrades-3.name": "Совершенная мастерская",
  "hall.seasonTask.season-upgrades-3.body": "Купите {target} улучшений. Бесплатный стартовый уровень не считается покупкой",
  "hall.seasonTask.season-arena-1.name": "Первый турнир",
  "hall.seasonTask.season-arena-1.body": "Завершите {target} матчей",
  "hall.seasonTask.season-arena-2.name": "Голос Арены",
  "hall.seasonTask.season-arena-2.body": "Завершите {target} матчей",
  "hall.seasonTask.season-arena-3.name": "Легенда Арены",
  "hall.seasonTask.season-arena-3.body": "Завершите {target} матчей",
  "hall.seasonTask.season-routes-1.name": "Верный путь",
  "hall.seasonTask.season-routes-1.body": "Заберите общую награду дня в {target} разных днях. Не обязательно подряд",
  "hall.seasonTask.season-routes-2.name": "Постоянство мастера",
  "hall.seasonTask.season-routes-2.body": "Заберите общую награду дня в {target} разных днях. Не обязательно подряд",
  "hall.seasonTask.season-routes-3.name": "Хроника месяца",
  "hall.seasonTask.season-routes-3.body": "Заберите общую награду дня в {target} разных днях. Не обязательно подряд",
  "hall.seasonTask.season-routes-4.name": "Безупречная серия",
  "hall.seasonTask.season-routes-4.body": "Заберите общую награду дня в {target} разных днях этого сезона",
  "hall.seasonTask.season-friends-1.name": "Первый союзник",
  "hall.seasonTask.season-friends-1.body": "Пригласите лично {target} мастера. Он должен добыть {threshold} тапами и в мастерской за этот сезон. Друзья друзей не входят в задание",
  "hall.seasonTask.season-friends-2.name": "Круг мастеров",
  "hall.seasonTask.season-friends-2.body": "Пригласите лично {target} мастеров. Каждый должен добыть {threshold} тапами и в мастерской за этот сезон. Друзья друзей не входят в задание",
  "hall.seasonTask.season-friends-3.name": "Гильдия граней",
  "hall.seasonTask.season-friends-3.body": "Пригласите лично {target} мастеров. Каждый должен добыть {threshold} тапами и в мастерской за этот сезон. Друзья друзей не входят в задание",
  "hall.seasonTask.season-channel.name": "Хроника квартала",
  "hall.seasonTask.season-channel.body": "Оставайтесь в канале до финала сезона",
  "hall.seasonTask.season-chat.name": "Совет мастеров",
  "hall.seasonTask.season-chat.body": "Оставайтесь в чате до финала сезона",
  "hall.seasonRuleTitle": "Что попадёт в итог",
  "hall.previousSeason": "Прошлый сезон",
  "hall.previousResult": "Лучшее место — № {place}",
  "hall.noPreviousResult": "Итог появится после завершения сезона",
  "hall.rankAfterFirstCarat": "После первого карата",
  "hall.worldToday": "Испытания дня",
  "hall.worldCollection": "Хранилище реликвий",
  "hall.worldSeason": "Хроника сезона",
  "hall.heroDailyProgress": "Выполнено: {current} из 3",
  "hall.heroDailyClaimed": "Печать дня завершена",
  "hall.heroDailyReward": "Внутри — {value}",
  "hall.collectionPermanent": "Знаки и титулы останутся после сезона",
  "hall.seasonHeroRule": "Место зависит от количества карат на балансе",
  "onboarding.keeperName": "Хранитель граней",
  "onboarding.welcomeKicker": "Первая смена",
  "onboarding.welcomeTitle": "Добро пожаловать в Квартал граней",
  "onboarding.welcomeBody": "Добывайте караты и увеличивайте свою долю в призовом фонде сезона.",
  "onboarding.seasonFundLabel": "Призовой фонд сезона",
  "onboarding.seasonFund": "Сейчас разыгрывается {fund}",
  "onboarding.seasonTime": "До распределения — {time}",
  "onboarding.seasonRule": "Чем больше карат останется на балансе к снимку, тем больше ваша доля фонда.",
  "onboarding.seasonNext": "После снимка начнётся новый сезон: производственные улучшения сбросятся, а знаки и облики останутся с вами.",
  "onboarding.begin": "Начать обучение",
  "onboarding.skip": "Пропустить",
  "onboarding.tapTitle": "Разбудите бриллиант",
  "onboarding.tapBody": "Сделайте 10 тапов. Каждый подтверждённый тап принесёт 10 карат.",
  "onboarding.tapProgress": "{current} из {target} тапов",
  "onboarding.mapTitle": "Откройте карту",
  "onboarding.mapBody": "Карта связывает Мастерскую, Зал трофеев, Клуб мастеров и Арену.",
  "onboarding.mapAction": "Открыть карту",
  "onboarding.workshopTitle": "Запустите мастерскую",
  "onboarding.workshopBody": "Начнём с Контура огранки — он добывает караты, даже когда вы не тапаете.",
  "onboarding.workshopAction": "Войти в Мастерскую",
  "onboarding.upgradeTitle": "Запустите первый механизм",
  "onboarding.upgradeBody": "Нажмите подсвеченную кнопку — Контур начнёт добывать караты сам.",
  "onboarding.upgradeAction": "Запустить Контур",
  "onboarding.passiveTitle": "Первая партия готова",
  "onboarding.passiveBody": "Заберите {value} карат. Дальше Контур огранки будет добывать их сам.",
  "onboarding.passiveClaim": "Забрать {value} карат",
  "onboarding.passiveProgress": "Получено {current} из {target} карат",
  "onboarding.trophyTitle": "Следите за прогрессом",
  "onboarding.trophyBody": "В Зале трофеев находятся задания дня, достижения и ваша сезонная доля.",
  "onboarding.trophyAction": "Открыть Зал трофеев",
  "onboarding.trophyOverviewTitle": "Задания, знаки и сезон",
  "onboarding.trophyOverviewBody": "«Сегодня» даёт награду за дневной маршрут. «Зал славы» сохраняет открытые знаки, а «Сезон» показывает вашу долю фонда.",
  "onboarding.trophyOverviewAction": "Показать сезон",
  "onboarding.seasonTitle": "Откройте хронику сезона",
  "onboarding.seasonBody": "Нажмите «Сезон», чтобы увидеть время до снимка и призовой фонд текущего сезона.",
  "onboarding.seasonAction": "Показать сезон",
  "onboarding.seasonOverviewTitle": "Снимок завершит сезон",
  "onboarding.seasonOverviewBody": "В указанное время призовой фонд распределится пропорционально каратам на балансах игроков. Чем больше ваш баланс к снимку, тем больше доля.",
  "onboarding.next": "Далее",
  "onboarding.seasonReturnTitle": "Вернитесь на карту",
  "onboarding.seasonReturnBody": "Сезон можно проверить в любое время. Карта вернёт вас к остальным местам квартала.",
  "onboarding.returnMapAction": "Вернуться на карту",
  "onboarding.clubTitle": "Соберите круг мастеров",
  "onboarding.clubBody": "Клуб показывает приглашённых друзей и караты, которые приносит их активная огранка.",
  "onboarding.clubAction": "Открыть Клуб мастеров",
  "onboarding.clubOverviewTitle": "Как работает ваш круг",
  "onboarding.clubOverviewBody": "Вы получаете {levelOne} карат, добытых друзьями тапами и в мастерской, и {levelTwo} от их друзей. Арена и сезонные награды не учитываются.",
  "onboarding.clubOverviewAction": "Показать приглашение",
  "onboarding.clubLinkTitle": "Пригласите мастера",
  "onboarding.clubLinkBody": "Личная ссылка уже готова. Нажмите «Копировать» и отправьте её другу — после входа он появится в вашем круге.",
  "onboarding.clubLinkAction": "Скопировать ссылку",
  "onboarding.clubReturnTitle": "Круг всегда под рукой",
  "onboarding.clubReturnBody": "Здесь видны приглашённые мастера и полученные караты. Вернитесь на карту — осталось познакомиться с Ареной.",
  "onboarding.arenaTitle": "Испытайте мастерство",
  "onboarding.arenaBody": "На Арене караты переходят между игроками: победитель забирает банк, новая валюта не создаётся.",
  "onboarding.arenaAction": "Открыть Арену",
  "onboarding.arenaOverviewTitle": "Выберите испытание",
  "onboarding.arenaOverviewBody": "На Арене несколько игр. Перед матчем вы увидите правила и ставку, а выигрыш перейдёт с баланса соперника.",
  "onboarding.arenaOverviewAction": "Показать игры",
  "onboarding.arenaGameTitle": "Хрустальный пенальти",
  "onboarding.arenaGameBody": "Первая игра — три серии ударов и сейвов. Правила и ставка откроются перед матчем; сыграть можно после обучения.",
  "onboarding.arenaGameTarget": "Карточка игры «Хрустальный пенальти»",
  "onboarding.arenaGameAction": "Завершить знакомство",
  "onboarding.arenaReturnTitle": "Всё готово к матчу",
  "onboarding.arenaReturnBody": "Здесь находятся ставка, правила и поиск соперника. Матч можно начать позже — обучение уже завершено.",
  "onboarding.arenaReturnAction": "Завершить обучение",
  "onboarding.completeKicker": "Маршрут освоен",
  "onboarding.completeTitle": "Квартал открыт",
  "onboarding.completeBody": "Всё готово: добывайте караты, развивайте мастерскую и увеличивайте оценку сезонной награды.",
  "onboarding.finish": "Начать добычу",
  "onboarding.recover": "Продолжить обучение",
  "club.kicker": "Гильдия квартала",
  "club.lead": "Мастера за одним столом",
  "club.body": "Друг сохраняет всё. Вам — {first} с друзей и {second} с друзей друзей после их первых {threshold}",
  "club.heroLabel": "Ваш круг",
  "club.heroMembers": "В клубе: {count}",
  "club.emptyHeroLabel": "Свободный стол",
  "club.emptyHeroLead": "Клуб ждёт мастеров",
  "club.emptyHeroBody": "Пригласите первого друга",
  "club.reward": "Начислено вам",
  "club.active": "В клубе",
  "club.produced": "Создано друзьями",
  "club.nextMilestone": "До следующего знака клуба — {count}",
  "club.filterAll": "Все",
  "club.filterA11y": "Фильтр мастеров",
  "club.searchLabel": "Найти мастера по имени",
  "club.searchPlaceholder": "Найти мастера…",
  "club.showing": "Показано {from}–{to} из {total}",
  "club.paginationA11y": "Страницы списка мастеров",
  "club.previousPage": "Предыдущая страница",
  "club.nextPage": "Следующая страница",
  "club.pageA11y": "Страница {page}",
  "club.noResultsTitle": "Мастер не найден",
  "club.noResultsBody": "Проверьте имя или выберите другой круг",
  "club.clearSearch": "Сбросить поиск",
  "club.inviteTitle": "Ссылка клуба",
  "club.inviteBody": "Друг появится здесь после первого входа",
  "club.copyLink": "Копировать ссылку",
  "club.memberContribution": "Произведено {value}",
  "club.memberProduced": "Произведено",
  "club.memberReward": "Вам",
  "club.emptyLead": "В клубе пока никого",
  "club.emptyBody": "Пригласите друга — после первого входа он появится за столом",
  "club.worldKicker": "Гильдия квартала",
  "club.worldTitle": "Ваш круг набирает силу",
  "club.worldEmptyTitle": "Зажгите первый знак",
  "club.worldEmptyBody": "Первый мастер появится здесь после входа",
  "club.worldProgress": "{count} мастеров · ещё {remaining} до нового знака",
  "club.worldReady": "{count} мастеров · новый знак клуба открыт",
  "club.inviteMaster": "Пригласить мастера",
  "club.filterAllV2": "Весь клуб",
  "club.filterNearCompact": "Ближние",
  "club.filterFarCompact": "Дальние",
  "club.filterNear": "Ближний круг",
  "club.filterFar": "Дальний круг",
  "club.filterCount": "{count} мастеров",
  "club.rewardKicker": "Сила клуба",
  "club.rewardTitle": "Награда клуба",
  "club.rewardNote": "Уже начислено на ваш баланс",
  "club.members": "Мастеров",
  "club.teamProduced": "Создано мастерами",
  "club.registrationReward": "За регистрации",
  "club.productionReward": "С добычи друзей",
  "club.milestone": "Знак клуба",
  "club.milestoneProgress": "{current} из {target}",
  "club.milestoneRemaining": "Пригласите ещё {count} мастеров",
  "club.milestoneReady": "Новый знак ждёт вас в Зале трофеев",
  "club.oathKicker": "Два круга",
  "club.oathTitle": "Что означают {first} и {second}",
  "club.nearBody": "{rate} от добычи приглашённого вами друга после первых {threshold}",
  "club.farBody": "{rate} от добычи друга вашего друга после первых {threshold}",
  "club.rateDetails": "Показать расчёт",
  "club.nearRateA11y": "Ближний круг: {rate} от добычи приглашённого вами друга после первых {threshold}. Показать расчёт",
  "club.farRateA11y": "Дальний круг: {rate} от добычи друга вашего друга после первых {threshold}. Показать расчёт",
  "club.thresholdRule": "Друг сохраняет все свои караты. Клуб начисляет вашу награду отдельно",
  "club.taskRule": "В заданиях учитываются личные приглашения — ближний круг. Друзья друзей приносят доход, но не увеличивают счётчик задания",
  "club.memberTaskCounted": "Засчитан в заданиях",
  "club.memberFarReward": "Доход без зачёта в заданиях",
  "club.memberNotInSeason": "Приглашён, но ещё не вошёл в этот сезон",
  "club.memberInSeason": "Играет в сезоне. До активности — {value}",
  "club.registerKicker": "Книга мастеров",
  "club.registerTitle": "Ваши мастера",
  "club.registerTotal": "Всего {count}",
  "club.searchPlaceholderV2": "Имя мастера",
  "club.memberThresholdA11y": "Путь мастера {name} к награде клуба",
  "club.memberEarning": "Приносит награду",
  "club.memberRemaining": "Ещё {value} до награды",
  "club.memberProducedV2": "Добыто за сезон",
  "club.memberRewardV2": "Вам",
  "club.noResultsTitleV2": "Такого мастера нет",
  "club.noResultsBodyV2": "Измените имя или откройте весь клуб",
  "club.clearSearchV2": "Показать весь клуб",
  "club.emptyLeadV2": "Книга ждёт первое имя",
  "club.emptyBodyV2": "Отправьте приглашение. Мастер появится после первого входа",
  "club.inviteGateKicker": "Врата клуба",
  "club.inviteGateTitle": "Откройте путь новому мастеру",
  "club.inviteGateBody": "Отправьте личную ссылку. После входа друг появится в Ближнем круге",
  "club.inviteLinkA11y": "Личная ссылка для приглашения",
  "club.inviteShare": "Поделиться",
  "club.inviteCopy": "Копировать ключ",
  "club.inviteShared": "Приглашение отправлено",
  "club.inviteCopied": "Ключ скопирован",
  "profile.kicker": "Профиль мастера",
  "profile.rank": "Лучшее место",
  "profile.currentSeason": "{season} идёт",
  "profile.seasons": "Сезоны",
  "profile.trophies": "Трофеи",
  "profile.collection": "Коллекция",
  "profile.collectionHint": "Трофеи и титулы остаются после смены сезона",
  "profile.selectedTrophy": "Выбранный знак",
  "profile.chooseTrophy": "Выбрать титул",
  "profile.noTitle": "Титул ещё не выбран",
  "profile.lockedTrophy": "Откройте в Зале трофеев",
  "profile.preferences": "Ощущения",
  "profile.musicHint": "Фоновая музыка во всех разделах",
  "profile.effectsHint": "Тапы и механизмы",
  "profile.vibrationHint": "Отклик на действия",
  "profile.reducedMotionHint": "Спокойные переходы и эффекты",
  "profile.help": "Помощь",
  "profile.rules": "Как считается сезон",
  "profile.support": "Написать в поддержку",
  "profile.client": "Diamond Kingdom · {version}",
  "profile.settingsHintV2": "Настройки звука и движения сохраняются на этом устройстве",
  "profile.rewardAccount": "Счёт наград Diamond Kingdom",
  "profile.rewardAccountHint": "Полученные сезонные награды в одном месте",
  "profile.plannedTokens": "По плановой цене: {value} токенов",
  "profile.openHall": "Открыть Зал славы",
  "rewardAccount.kicker": "Королевская казна",
  "rewardAccount.title": "Ваш счёт наград",
  "rewardAccount.body": "Здесь хранятся полученные сезонные награды и помощь наставника. Участие в следующем сезоне не зависит от оплаты предыдущего.",
  "rewardAccount.balanceLabel": "Накоплено по расчётной стоимости",
  "rewardAccount.balanceHint": "Сезонные награды и полученные переводы с учётом расходов",
  "rewardAccount.historyKicker": "Хроника казны",
  "rewardAccount.historyTitle": "История наград",
  "rewardAccount.emptyTitle": "Казна ждёт первую награду",
  "rewardAccount.emptyBody": "Получите сезонную награду в срок — здесь появятся её стоимость и запись в истории.",
  "rewardAccount.entrySeason": "Получена награда · {season}",
  "rewardAccount.entryPartnerIn": "Получена помощь наставника",
  "rewardAccount.entryPartnerOut": "Помощь мастеру отправлена",
  "rewardAccount.entryWallet": "Использовано для получения токенов",
  "rewardAccount.entryDiamond": "Перенесено в приложение Diamond",
  "rewardAccount.entryLpReserve": "Средства направлены на создание LP",
  "rewardAccount.entryLpRefund": "Средства за LP возвращены",
  "rewardAccount.entryLpCreated": "Персональная LP-позиция создана",
  "rewardAccount.externalOperation": "Операция со счётом",
  "rewardAccount.referenceTitle": "Как считается стоимость",
  "rewardAccount.referenceRate": "Опубликованная стартовая цена: {value}",
  "rewardAccount.referenceNote": "Сумма рассчитана по опубликованной стартовой цене игрового токена. Это ориентир, а не фиксированный курс или обещание выплаты. После запуска рыночная цена токена может измениться.",
  "shop.kicker": "Хранилище редкостей",
  "shop.title": "Премиальная лавка",
  "shop.open": "Открыть премиальную лавку",
  "shop.openShort": "Лавка",
  "shop.backToGame": "В игру",
  "shop.lead": "Усиления, облики и редкие знаки",
  "shop.reserve": "Запас офлайн-времени",
  "shop.boosts": "Усиления",
  "shop.none": "Нет активных",
  "shop.queued": "В очереди: {count}",
  "shop.reserveAvailable": "В запасе ещё {time} дополнительной офлайн-добычи",
  "shop.boostActive": "Усиление действует ещё {time}",
  "boost.tapActive": "Тапы +{percent}%",
  "boost.tapQueued": "Усиление начнётся через",
  "boost.perTap": "+{value} карат за тап",
  "boost.next": "Следом включится: {count}",
  "boost.sequential": "Усиления работают по очереди: следующая покупка продлевает время, а не складывает проценты.",
  "boost.passiveActive": "Пассивная добыча усилена ещё {time}",
  "shop.categories": "Категории лавки",
  "shop.category.reserve": "Офлайн",
  "shop.category.booster": "Усиления",
  "shop.category.skin": "Облики",
  "shop.category.signet": "Старт",
  "shop.permanent": "Весь сезон",
  "shop.purchaseCount": "Покупки за сезон: {count} из {limit}",
  "shop.purchaseLimit": "Покупок за сезон — до {limit}",
  "shop.limitReached": "Исчерпано",
  "shop.limitReachedHint": "Лимит на этот сезон исчерпан",
  "shop.endsIn": "Ещё {time}",
  "shop.opensWithSeason": "Откроется со стартом сезона",
  "shop.finished": "Предложение завершено",
  "shop.featured": "Выбор сезона",
  "shop.owned": "Получено",
  "shop.inCollection": "В коллекции",
  "shop.selected": "Выбран",
  "shop.wear": "Надеть",
  "shop.preview": "Примерить",
  "shop.previewing": "В примерке",
  "shop.buy": "{stars} ⭐",
  "shop.starsNote": "Цена указана в Telegram Stars. Усиления запускаются последовательно и не сжигают оплаченное время.",
  "shop.reserveNote": "Оплата — в Telegram Stars. Дополнительные часы складываются и не сгорают, пока не используются.",
  "shop.collectionNote": "Оплата — в Telegram Stars. Облики и знаки навсегда останутся в коллекции.",
  "shop.startGrantNote": "Каждая покупка заново считает бонус только от подтверждённой ручной добычи. Пассивная добыча и прошлые покупки в расчёт не входят.",
  "shop.startWindow.kicker": "Предложение старта",
  "shop.startWindow.title": "Королевский запас",
  "shop.startWindow.active": "До закрытия · {time}",
  "shop.startWindow.upcoming": "Откроется со стартом сезона",
  "shop.startWindow.expired": "Стартовое окно закрыто",
  "shop.startWindow.base": "Добыто тапами: {value}",
  "shop.startWindow.grantNow": "Сейчас добавится",
  "shop.startWindow.grantEmpty": "Сначала добудьте караты тапами",
  "shop.offer.season-start-taps-10.name": "Стартовый импульс · +10%",
  "shop.offer.season-start-taps-10.body": "10% от карат, добытых подтверждёнными тапами к моменту покупки",
  "shop.offer.season-start-taps-30.name": "Королевский прирост · +30%",
  "shop.offer.season-start-taps-30.body": "30% от карат, добытых подтверждёнными тапами к моменту покупки",
  "shop.offer.season-start-taps-50.name": "Великий запас · +50%",
  "shop.offer.season-start-taps-50.body": "50% от карат, добытых подтверждёнными тапами к моменту покупки",
  "shop.offer.offline-reserve-starter-8h.name": "Первый запас · ещё 8 часов",
  "shop.offer.offline-reserve-starter-8h.body": "Один раз за сезон: мастерская продолжит добычу ещё 8 часов после бесплатного лимита.",
  "shop.offer.offline-reserve-8h.name": "Ещё 8 часов добычи",
  "shop.offer.offline-reserve-8h.body": "Мастерская продолжит добычу после бесплатных 4 часов. Время тратится только пока вас нет.",
  "shop.offer.offline-reserve-12h.name": "Ещё 12 часов добычи",
  "shop.offer.offline-reserve-12h.body": "Мастерская продолжит добычу после бесплатных 4 часов. Время тратится только пока вас нет.",
  "shop.offer.offline-reserve-24h.name": "Ещё 24 часа добычи",
  "shop.offer.offline-reserve-24h.body": "Мастерская продолжит добычу после бесплатных 4 часов. Время тратится только пока вас нет.",
  "shop.offer.passive-boost-20-24h.name": "Турбина мастерской",
  "shop.offer.passive-boost-20-24h.body": "+20% к текущей пассивной скорости на 24 часа",
  "shop.offer.passive-boost-20-6h.name": "Искра турбины",
  "shop.offer.passive-boost-20-6h.body": "+20% к текущей пассивной скорости на 6 часов",
  "shop.offer.tap-boost-50-30m.name": "Импульс огранщика",
  "shop.offer.tap-boost-50-30m.body": "+50% к силе каждого тапа на 30 минут",
  "shop.offer.skin-aurora-prism.name": "Облик «Призма Авроры»",
  "shop.offer.skin-aurora-prism.body": "Постоянный бирюзово-золотой облик. Не увеличивает добычу",
  "shop.offer.skin-black-diamond.name": "Чёрный бриллиант",
  "shop.offer.skin-black-diamond.body": "Тёмная звёздная огранка. Сохраняется после сезона, не увеличивает добычу",
  "shop.offer.skin-solar-heart.name": "Сердце солнца",
  "shop.offer.skin-solar-heart.body": "Золотая огранка с янтарным светом. Постоянный облик без прибавки к добыче",
  "shop.offer.skin-emerald-abyss.name": "Изумрудная бездна",
  "shop.offer.skin-emerald-abyss.body": "Бирюзовый облик с огненными искрами. Сохраняется после сезона, не увеличивает добычу",
  "shop.skin.default.name": "Классическая огранка",
  "shop.skin.default.body": "Основной облик бриллианта — доступен всегда",
  "shop.offer.season-01-signet.name": "Знак первого сезона",
  "shop.offer.season-01-signet.body": "Один редкий знак на сезон; навсегда остаётся в Зале славы",
  "collection.seasonZeroParticipant.name": "Участник Сезона 0",
  "shop.offer.generic.offline-reserve.name": "Дополнительная добыча",
  "shop.offer.generic.offline-reserve.body": "Мастерская будет добывать ещё {duration} после бесплатного времени.",
  "shop.offer.generic.passive-boost.name": "Усиление мастерской",
  "shop.offer.generic.passive-boost.body": "+{percent}% к пассивной добыче на {duration}",
  "shop.offer.generic.tap-boost.name": "Усиление огранки",
  "shop.offer.generic.tap-boost.body": "+{percent}% к каждому тапу на {duration}",
  "rewardReveal.kicker": "Новая реликвия",
  "rewardReveal.saved": "Сохранено в Зале славы",
  "rewardReveal.continue": "Продолжить",
  "collection.rarity.common": "Обычный знак",
  "collection.rarity.rare": "Редкий знак",
  "collection.rarity.epic": "Эпическая реликвия",
  "collection.rarity.legendary": "Легендарная реликвия",
  "collection.kind.achievement": "Достижение мастерства",
  "collection.kind.season-signet": "Памятный знак сезона",
  "collection.kind.cosmetic": "Постоянный облик",
  "collection.source": "Источник",
  "collection.received": "Получено",
  "collection.source.achievement": "Достижение",
  "collection.source.legacy-achievement": "Ранее полученное достижение",
  "collection.source.premium-shop": "Премиальная лавка",
  "collection.source.season-zero-participation": "Участие в Сезоне 0",
  "collection.offChain": "Хранится в игре; выпуск NFT пока не включён",
  "status.networkTitle": "Нет соединения",
  "status.musicUnavailable": "Музыка не загрузилась. Проверьте соединение и включите её снова",
  "status.networkBody": "Восстанавливаем связь автоматически",
  "status.tapSyncTitle": "Сохраняем добычу…",
  "spend.saving": "Сохраняем добычу…",
  "spend.sending": "Выполняем…",
  "spend.savingBody": "Тапов осталось сохранить: {count}. Затем действие продолжится автоматически. Закройте окно, чтобы отменить его.",
  "spend.sendingBody": "Ждём подтверждения. Повторно нажимать не нужно.",
  "spend.stalledTitle": "Сохранение задержалось",
  "spend.stalledBody": "Тапы остаются на устройстве. Дождитесь сохранения и повторите действие.",
  "status.tapSyncBody": "Тапы сохранены на устройстве и отправляются автоматически",
  "status.retry": "Повторить",
  "status.restored": "Связь восстановлена. Баланс обновлён",
  "status.partial": "Принято тапов: {accepted} из {requested}",
  "status.tapsConfirmed": "Начислено {value}. Баланс {balance}",
  "status.offline": "Мастерская произвела {value}",
  "status.upgraded": "Контур запущен · +{value}",
  "status.precisionUpgraded": "Резонансный резец усилен",
  "status.precisionUpgradeBody": "Награда за тап теперь: {value}",
  "status.mechanicalUpgraded": "Контур огранки усилен",
  "status.mechanicalUpgradeBody": "Скорость добычи теперь: {value}",
  "status.energyCapacityUpgraded": "Накопитель усилен",
  "status.energyCapacityBody": "Запас энергии теперь: {value}",
  "status.energyRecoveryUpgraded": "Поток ускорен",
  "status.energyRecoveryBody": "Теперь 1 энергия возвращается за {value} с",
  "upgradeConfirm.kicker": "Подтверждение",
  "upgradeConfirm.title": "Усилить «{name}»?",
  "upgradeConfirm.body": "Откроется уровень {level} из {max}",
  "upgradeConfirm.balance": "Сейчас",
  "upgradeConfirm.cost": "Стоимость",
  "upgradeConfirm.after": "Останется",
  "upgradeConfirm.note": "Караты спишутся сразу. Отменить улучшение нельзя",
  "upgradeConfirm.cancel": "Не сейчас",
  "upgradeConfirm.confirm": "Подтвердить",
  "status.energyRefilled": "Энергия восстановлена",
  "status.energyRefilledBody": "+{value} энергии · быстрых зарядов осталось: {count}",
  "status.energyEmpty": "Энергия закончилась",
  "status.energyEmptyBody": "Она восстанавливается сама. Накопитель можно зарядить быстрее",
  "status.notEnoughHint": "Ограняйте бриллиант или дождитесь добычи Контура",
  "offline.kicker": "С возвращением",
  "offline.title": "Мастерская принесла вам караты",
  "offline.body": "Пока вас не было, Контур огранки продолжал работать",
  "offline.earned": "Добыто",
  "offline.duration": "Время работы: {duration}",
  "offline.action": "Продолжить",
  "offline.loadingTitle": "Мастерская готовит награду",
  "offline.loadingBody": "Собираем добытые караты…",
  "offline.loadingProgress": "Подготовка награды",
  "offline.loadingError": "Награда пока не открылась",
  "offline.loadingErrorBody": "Проверьте соединение и попробуйте снова",
  "offline.loadingRetry": "Попробовать снова",
  "help.open": "Открыть правила раздела «{section}»",
  "help.kicker": "Как это работает",
  "help.seasonNote": "Потраченные караты не входят в сезонный остаток. Перед улучшением сравните цену и будущий прирост",
  "help.workshop.title": "Мастерская",
  "help.workshop.lead": "Четыре механизма управляют добычей и энергией",
  "help.workshop.mechanicalTitle": "Контур огранки",
  "help.workshop.mechanicalLabel": "Добыча без тапов",
  "help.workshop.mechanicalBody": "Добывает караты, даже когда игра закрыта",
  "help.workshop.precisionTitle": "Резонансный резец",
  "help.workshop.precisionLabel": "Награда за тап",
  "help.workshop.precisionBody": "Увеличивает караты за касание бриллианта",
  "help.workshop.capacityTitle": "Кристальный накопитель",
  "help.workshop.capacityLabel": "Запас энергии",
  "help.workshop.capacityBody": "Позволяет дольше огранять без паузы",
  "help.workshop.recoveryTitle": "Поток восстановления",
  "help.workshop.recoveryLabel": "Скорость заряда",
  "help.workshop.recoveryBody": "Повышает скорость восстановления энергии",
  "help.workshop.action": "Понятно",
  "help.hall.title": "Зал трофеев",
  "help.hall.lead": "Зал объединяет задачи дня, постоянную коллекцию и результат текущего сезона",
  "help.hall.rule1": "Задачи дня учитывают подтверждённые тапы, общую выработку и отдельную работу Контура за текущий UTC-день",
  "help.hall.rule2": "Полученные трофеи и выбранный титул сохраняются между сезонами",
  "help.hall.rule3": "Место и оценка награды зависят от количества карат на балансе в момент сезонного снимка",
  "help.club.title": "Клуб мастеров",
  "help.club.lead": "Клуб награждает за реальную активность приглашённых игроков, не отнимая у них караты",
  "help.club.rule1": "Друг сохраняет всю свою выработку. Когда он произведёт первые {threshold}, вам отдельно начисляется {first} с его следующих тапов и работы мастерской",
  "help.club.rule2": "С друзей друзей начисляется {second} по тому же правилу и только после их собственного порога",
  "help.club.rule3": "В расчёт не входят PvP, награды клуба, задания, достижения, сезонные выплаты, возвраты и административные корректировки",
  "help.club.rule4": "Поиск работает по имени. Фильтры разделяют друзей и друзей друзей; список разбит на страницы",
  "help.club.note": "Начисление клуба не уменьшает баланс друга и само не создаёт новых клубных начислений",
  "help.club.kickerV2": "Награда клуба",
  "help.club.titleV2": "Как работают {first} и {second}",
  "help.club.leadV2": "За подтверждённую регистрацию друга вы получаете разовую награду. Проценты с его добычи начинаются после {threshold}",
  "help.club.registration": "За каждую подтверждённую регистрацию друга первой линии: {value}",
  "help.club.nearBody": "Вы пригласили друга. После первых {threshold} клуб начисляет вам {rate} от его дальнейшей добычи",
  "help.club.farBody": "Друг пригласил игрока. После первых {threshold} клуб начисляет вам {rate} от его дальнейшей добычи",
  "help.club.exampleKicker": "Пример расчёта",
  "help.club.exampleTitle": "Друг добыл {production}",
  "help.club.exampleEquationA11y": "{production} минус первые {threshold} равно {eligible}, которые участвуют в расчёте",
  "help.club.exampleEligible": "В расчёт входят только {eligible}",
  "help.club.exampleNearLabel": "Если пригласили вы",
  "help.club.exampleFarLabel": "Если пригласил ваш друг",
  "help.club.exampleFormula": "{eligible} × {rate}",
  "help.club.exampleToYou": "начисляется вам",
  "help.club.exampleKeeps": "Друг сохраняет все {production}. Клуб начисляет вашу награду отдельно",
  "help.club.countsTitle": "Считается добычей",
  "help.club.countsBody": "Тапы по бриллианту и пассивная добыча Контура огранки",
  "help.club.excludesTitle": "Не участвует в расчёте",
  "help.club.excludesBody": "PvP, задания, достижения, награды клуба, сезонные выплаты и возвраты",
  "help.club.noteV2": "Награда клуба сама не приносит новые {first} или {second}",
  "help.club.action": "Понятно",
  "help.arena.title": "Арена",
  "help.arena.lead": "На Арене мастера соревнуются в коротких играх на караты",
  "help.arena.rule1": "Выберите игру и внесите указанную ставку. Соперник внесёт столько же",
  "help.arena.rule2": "Победитель получит общий банк. При ничьей или отмене матча ставка вернётся",
  "help.arena.rule3": "Если живой соперник не найден, к матчу присоединится Страж Арены",
  "help.arena.rule4": "У каждой игры свои правила",
  "help.arena.note": "Откройте правила в карточке игры перед матчем",
  "help.penalty.kicker": "Правила игры",
  "help.penalty.lead": "В каждой серии вы один раз бьёте и один раз защищаете ворота",
  "help.penalty.rule1": "Выберите одно из трёх направлений: влево, по центру или вправо. На выбор — {turnSeconds} секунд",
  "help.penalty.rule2": "Вратарь отобьёт мяч, если угадает направление удара",
  "help.penalty.rule3": "После трёх серий при равном счёте идут решающие серии. Если счёт не изменится, матч завершится вничью",
  "help.penalty.stake": "Ставка — {stake}. Победитель получает {bank}; при ничьей ставка возвращается",
  "help.penalty.action": "Понятно",
  "status.titleSelected": "Титул «{name}» выбран",
  "status.dailyReward": "Награда дня получена · {value}",
  "status.seasonTaskClaimed": "Награда сезонного задания получена",
  "status.membershipChecked": "Подписка подтверждена",
  "status.membershipMissing": "Подписка пока не найдена",
  "status.premiumPurchased": "Реликвия добавлена в вашу мастерскую",
  "status.skinSelected": "Облик бриллианта изменён",
  "status.achievementNamed": "Знак «{name}» добавлен в коллекцию",
  "status.achievement": "Знак «Живая грань» получен",
  "status.reward": "Сезонная награда получена",
  "status.seasonInactive": "Производство временно недоступно. Откройте сезон",
  "status.actionUnavailable": "Действие пока недоступно",
  "status.previousTaskRequired": "Сначала получите награду за предыдущее задание этой цепочки",
  "status.taskNotComplete": "Задание ещё не выполнено. Проверьте его условия и прогресс",
  "status.tapUnavailable": "Не удаётся засчитать тапы. Напишите в поддержку через профиль",
  "status.clubInviteCopied": "Ключ приглашения скопирован",
  "status.clubInviteCopyFailed": "Ссылка не скопировалась. Отправьте её кнопкой «Поделиться»",
  "status.clubInviteShared": "Приглашение отправлено",
  "common.close": "Закрыть",
  "common.skip": "К игре",
  "common.ready": "Готово",
  "common.on": "Включено",
  "common.off": "Выключено",
  "dev.title": "Сценарии проверки",
  "dev.firstEntry": "Первый вход",
  "dev.afterUpgrade": "После улучшения",
  "dev.insufficient": "Недостаточно валюты",
  "dev.network": "Потеря сети",
  "dev.partial": "Частично принятые тапы",
  "dev.offline": "Офлайн-выработка",
  "dev.projectionWarmup": "Оценка формируется",
  "dev.scheduled": "Сезон не начался",
  "dev.scheduledWithClaim": "Новый сезон ожидается, награда доступна",
  "dev.frozen": "Сезон заморожен",
  "dev.settling": "Подводим итог сезона",
  "dev.rewardReady": "Награда готова",
  "dev.rewardReceived": "Награда получена",
  "dev.tonUsdtPrizeActive": "Призы 500 USDT · активный сезон",
  "dev.tonUsdtPrizeWinner": "Приз 200 USDT · победитель",
  "dev.communityMissing": "Нет подписки на сообщество",
  "dev.emptyFriends": "Пустые друзья",
  "dev.arenaReady": "Арена · готов к матчу",
  "dev.arenaResultStack": "Арена · цепочка результатов",
  "dev.activePvp": "Активный матч",
  "dev.largeBalance": "Баланс · 17 миллионов",
  "dev.visualStage3": "Бриллиант · ступень 3",
  "dev.visualStage4": "Бриллиант · ступень 4",
  "dev.energyEmpty": "Энергия закончилась",
  "dev.reduced": "Reduced motion",
  "dev.hide": "Скрыть сценарии",
  "hall.globalRewardReady": "Наград готово: {count}",
  "hall.globalRewardPortal": "Зал трофеев · готово: {count}",
  "hall.mapRewardKicker": "Зал трофеев",
  "hall.mapRewardAction": "Забрать награды",
} as const;

export type TranslationKey = keyof typeof ru;
type Dictionary = Record<TranslationKey, string>;

const en: Dictionary = {
  "app.title": "Kinetic Faceting Workshop",
  "loading.title": "Loading the workshop…",
  "loading.kingdom": "Opening the kingdom…",
  "loading.diamond": "Awakening the diamond…",
  "loading.workshop": "Lighting the Workshop…",
  "loading.trophies": "Preparing the Trophy Hall…",
  "loading.arena": "Opening the Arena…",
  "loading.retry": "Try again",
  "common.soon": "soon",
  "common.and": "and",
  "currency.name": "Carats",
  "currency.short": "car.",
  "header.profile": "Open profile",
  "header.season": "Season remaining",
  "header.seasonStarts": "Season starts in",
  "header.claimCloses": "Reward claim closes in",
  "header.balance": "Carats",
  "header.seasonShort": "Season",
  "header.seasonFund": "Season fund",
  "header.estimateNow": "now",
  "header.estimatePending": "until estimate",
  "header.estimatePendingValue": "{time}",
  "header.estimatedReward": "Current reward estimate",
  "header.balanceDetails": "Open carat balance",
  "header.passiveTitle": "Production",
  "header.passive": "+{value}",
  "header.noPassive": "0/s",
  "header.inGame": "In matches {value}",
  "nav.label": "Main sections",
  "nav.core": "Diamond",
  "nav.development": "Workshop",
  "nav.progress": "Trophy Hall",
  "nav.friends": "Makers Club",
  "nav.games": "Arena",
  "map.world": "World map",
  "map.title": "Facet Quarter",
  "map.open": "Open the Facet Quarter",
  "map.home": "Return to the diamond",
  "map.diamond": "Diamond",
  "map.development": "Workshop",
  "map.developmentHint": "Upgrades",
  "map.progress": "Trophy Hall",
  "map.progressHint": "Goals and season",
  "map.friends": "Makers Club",
  "map.friendsHint": "Friends",
  "map.games": "Arena",
  "map.gamesHint": "Matches",
  "map.openDevelopment": "Open the Workshop",
  "map.openProgress": "Open the Trophy Hall",
  "map.openFriends": "Open the Makers Club",
  "map.openGames": "Open the Arena",
  "map.back": "Map",
  "map.backA11y": "Return to map",
  "core.tapHint": "Tap the diamond",
  "core.tapButton": "Facet the diamond",
  "core.tapArea": "Facet the diamond, reward {value}",
  "core.nextUpgrade": "Start cutter · {cost}",
  "core.needMore": "Need {value} more",
  "core.cutterWorking": "Mechanical cutter · +{value}",
  "core.openDevelopment": "Open development",
  "core.seasonScheduled": "The workshop is waiting for the season",
  "core.seasonFrozen": "The workshop is paused for settlement",
  "core.rewardReady": "Season reward is ready",
  "core.rewardReceived": "Season reward received",
  "development.title": "Faceting Workshop",
  "development.stage": "Diamond · stage {stage}",
  "development.nextStage": "The next stage changes the diamond frame and glow",
  "development.faceting": "Faceting",
  "development.mechanisms": "Mechanisms",
  "development.manualTool": "Hand faceting",
  "development.manualLevel": "Level 1",
  "development.manualCurrent": "Current: +{value} per tap",
  "development.manualNext": "The next effect unlocks after the first drive",
  "development.cutter": "Faceting circuit",
  "development.level": "Level {level}",
  "development.currentIdle": "Current: 0/s",
  "development.currentActive": "Current: +{value}",
  "development.nextActive": "After upgrade: +{value}",
  "development.installed": "Circuit running",
  "development.upgrade": "Upgrade for {cost}",
  "development.details": "Circuit details",
  "development.sheetTitle": "Faceting circuit",
  "development.sheetBody": "An energy frame gathers carats between taps",
  "development.sheetCurrent": "Current production",
  "development.sheetAfter": "After launch",
  "development.sheetVisual": "The diamond gains a teal frame, copper girdle, and glowing center",
  "development.notEnough": "Need {value} more",
  "development.returnCore": "Return to the diamond",
  "progress.title": "Trophy Hall",
  "progress.today": "Today",
  "progress.achievements": "Hall of Fame",
  "progress.season": "Season",
  "progress.taskTaps": "Make {target} taps",
  "progress.taskPassive": "Receive {target} from the workshop",
  "progress.taskValue": "{current}/{target}",
  "progress.completed": "Complete",
  "progress.daySummary": "Goals follow confirmed progress",
  "progress.achievementTitle": "Living facet",
  "progress.achievementBody": "Start the faceting circuit",
  "progress.achievementReady": "Badge ready",
  "progress.achievementClaim": "Claim badge",
  "progress.achievementClaimed": "Badge claimed",
  "progress.ranking": "Nearby ranks",
  "progress.you": "You",
  "progress.place": "No. {place}",
  "progress.pool": "Season pool",
  "progress.estimate": "Estimated value: {value}",
  "progress.estimateNote": "The estimate may change before the balance snapshot",
  "progress.snapshotRule": "Your carat balance at the season snapshot determines the final result",
  "progress.activeSeasonTitle": "Season in progress",
  "progress.activeSeasonBody": "Time remaining: {time}",
  "progress.seasonScheduledTitle": "Season starts soon",
  "progress.seasonScheduledBody": "Starts {date}",
  "progress.seasonFrozenTitle": "Season complete",
  "progress.seasonFrozenBody": "Calculating results. The reward will appear when ready",
  "progress.seasonSettlingTitle": "Finalizing results",
  "progress.seasonSettlingBody": "Your balance is locked while the calculation runs",
  "progress.rewardReadyTitle": "Reward ready",
  "progress.rewardReadyBody": "Estimated value — {value}",
  "progress.rewardClaim": "Claim reward",
  "progress.rewardClaimStars": "Claim for {stars} ⭐",
  "progress.rewardClaimedTitle": "Reward claimed",
  "progress.rewardClaimedBody": "The equivalent is stored in your Diamond Kingdom account",
  "progress.rewardExpiredTitle": "Claim window closed",
  "progress.rewardExpiredBody": "This season reward can no longer be claimed",
  "friends.title": "Makers Club",
  "friends.lead": "Build together",
  "friends.body": "Receive part of the currency active friends produce themselves",
  "friends.invite": "Invite a friend",
  "friends.lineOne": "Friends",
  "friends.lineTwo": "Friends of friends",
  "friends.contribution": "Produced {value}",
  "friends.total": "Team produced {value}",
  "friends.emptyTitle": "Your team is empty",
  "friends.emptyBody": "Invite a friend. They appear in the club after their first visit",
  "friends.shareTitle": "Diamond Kingdom",
  "friends.shareText": "Join my Makers Club",
  "friends.copied": "Invite link copied",
  "games.title": "Arena",
  "games.catalogKicker": "Game hall",
  "games.catalogTitle": "Choose a challenge",
  "games.catalogBody": "Each game tests a different skill and uses the same carat balance",
  "games.catalogOpen": "Open",
  "games.catalogSoon": "Coming soon",
  "games.catalogEnter": "Open game",
  "games.catalogBack": "All games",
  "games.catalogPenaltyTag": "Precision versus reaction",
  "games.catalogResonance": "Resonance Rush",
  "games.catalogResonanceBody": "Hold the impulse inside a shifting crystal circuit",
  "games.catalogRelic": "Relic Duel",
  "games.catalogRelicBody": "Spread five impulses across the relics and score more points",
  "games.catalogRelicTag": "Five relics · five decisions",
  "games.catalogComingSoon": "This challenge will open in a future update",
  "games.relicKicker": "Trial of wit",
  "games.relicTitle": "Relic Duel",
  "games.relicSubtitle": "Each relic has a value. Decide where to spend your strongest impulse",
  "games.relicChooseTable": "Choose a table",
  "games.relicTableHint": "In this test, the stake sets the duel tier but is not deducted",
  "games.relicPreviewNotice": "Training duel · no carats are deducted",
  "games.relicPreviewBadge": "Test",
  "games.relicBackShort": "Games",
  "games.relicOpponent": "Guardian",
  "games.relicYou": "You",
  "games.relicVersus": "VS",
  "games.relicRound": "Round",
  "games.relicRoundPot": "At stake",
  "games.relicChooseImpulse": "Choose an impulse",
  "games.relicImpulseHint": "Each strength can be used only once",
  "games.relicLocked": "Choice locked",
  "games.relicAutoMove": "Time is up · move chosen",
  "games.relicPlayerRoundWin": "Relic claimed",
  "games.relicOpponentRoundWin": "Guardian claims it",
  "games.relicTieRound": "Equal impulses.",
  "games.relicCarryPot": "Next pot",
  "games.relicResultWin": "Duel won",
  "games.relicResultLoss": "Guardian wins",
  "games.relicResultDraw": "Facets in balance",
  "games.relicResultWinBody": "You allocated your strength more precisely",
  "games.relicResultLossBody": "Try saving a strong impulse for a valuable relic",
  "games.relicResultDrawBody": "Your strength was equal. A new impulse order can change the outcome",
  "games.relicPlayAgain": "Play again",
  "games.relicChooseAnotherTable": "Choose another table",
  "games.relicStrength": "power",
  "games.relicCanvasLabel": "Relic Duel. Choose a table, then choose an impulse from one to five in each round",
  "games.available": "Available",
  "games.reserved": "In matches",
  "games.stake": "Your stake",
  "games.playFor": "Play for {value}",
  "games.penalty": "Crystal Penalty",
  "games.penaltyBody": "Three rounds of shots and saves. The best score takes the shared pot",
  "games.rules": "Game rules",
  "games.bank": "Match pot",
  "games.eachStake": "You and your opponent stake {value} each",
  "games.searchTitle": "Finding an opponent",
  "games.searchBody": "The Arena Guardian joins in {seconds}",
  "games.searching": "Searching",
  "games.loadingArena": "Loading the Arena",
  "games.loadingScene": "Positioning the players",
  "games.loadingCount": "{loaded} of {total} objects",
  "games.cancel": "Cancel search",
  "games.guardianChoice": "Challenge the Guardian",
  "games.guardianChoiceBody": "Start now instead of waiting for another player",
  "games.found": "Opponent found",
  "games.guardianReady": "Your opponent is ready",
  "games.zonePrompt": "Choose a direction",
  "games.savePrompt": "Choose a dive",
  "games.zoneLabel": "Zone {zone}",
  "games.shotZone": "Shoot: {zone}",
  "games.saveZone": "Dive: {zone}",
  "games.zone.1": "Left",
  "games.zone.2": "Centre",
  "games.zone.3": "Right",
  "games.zone.4": "Bottom left",
  "games.zone.5": "Bottom right",
  "games.roleShot": "Your shot",
  "games.roleSave": "You are in goal",
  "games.moveAccepted": "Direction chosen",
  "games.waitOpponent": "Waiting for opponent",
  "games.autoMove": "Time expired — the system chose a zone",
  "games.turnTime": "Time to choose",
  "games.series": "Round {current} of {total}",
  "games.suddenDeath": "Deciding round {current}",
  "games.scoreYou": "You",
  "games.scoreOpponent": "Guardian",
  "games.goal": "Goal",
  "games.save": "Save",
  "games.attemptsYou": "Your shots",
  "games.attemptsOpponent": "Opponent shots",
  "games.attemptGoal": "Goal",
  "games.attemptSave": "Shot saved",
  "games.calloutYouScored": "You scored",
  "games.calloutOpponentSaved": "Opponent saved",
  "games.calloutYouSaved": "You saved it",
  "games.calloutYouConceded": "You conceded",
  "games.resultWin": "Arena victory",
  "games.resultLoss": "Opponent wins",
  "games.resultDraw": "Scores level",
  "games.resultCancelled": "Search cancelled",
  "games.resultWinBody": "Your stake returned together with your winnings",
  "games.resultLossBody": "Your stake went to the winner",
  "games.resultDrawBody": "Your stake was fully returned",
  "games.resultCancelledBody": "Your stake was returned",
  "games.matchBank": "Pot: {value}",
  "games.resultPayout": "You received {value}",
  "games.resultRefund": "Stake returned: {value}",
  "games.yourZone": "Your choice: zone {zone}",
  "games.opponentZone": "Opponent choice: zone {zone}",
  "games.playAgain": "Play again",
  "games.returnArena": "Return to Arena",
  "games.notEnough": "Need {value} more for this stake",
  "games.syncRestored": "Match updated",
  "games.syncRestoredBody": "The latest state is restored. Continue playing",
  "games.leaveTitle": "Leave the match?",
  "games.leaveBody": "The match stays active. You can return to it from the Arena",
  "games.leave": "Open section",
  "games.stay": "Stay in game",
  "profile.title": "Profile",
  "profile.name": "Master Alex",
  "profile.subtitle": "Season faceter",
  "profile.music": "Music",
  "profile.effects": "Effects",
  "profile.vibration": "Vibration",
  "profile.reducedMotion": "Reduce motion",
  "profile.language": "Language",
  "profile.russian": "Русский",
  "profile.english": "English",
  "profile.settingsHint": "Settings are saved on this device",
  "profile.reset": "Reset demo state",
  "profile.close": "Close profile",
  "sheet.close": "Close",
  "balance.title": "Balance",
  "balance.available": "Available",
  "balance.reserved": "Reserved",
  "balance.production": "Production",
  "balance.unitPerSecond": "{value}",
  "balance.kicker": "Season treasury",
  "balance.hero": "Carats",
  "balance.availableNow": "Carat balance",
  "balance.estimateLabel": "Estimated in USDT",
  "balance.estimateIfNow": "If the season ended now",
  "balance.estimatePreparing": "Estimate is forming",
  "balance.estimateRevealsIn": "Unlocks in {time}",
  "balance.estimateWarmupBody": "Your carats already count toward the season. The USDT estimate stays hidden for the opening days until the distribution becomes meaningful.",
  "balance.estimateWarmupNote": "This does not affect the result: the carats remaining on your balance will enter the season snapshot.",
  "balance.fund": "Season prize fund",
  "balance.caratBody": "Carats are the Quarter's game currency. Your balance at the end of the season determines your share of the prize fund.",
  "balance.caratSources": "Earn them through faceting, Workshop production, and rewards.",
  "balance.rewardTitle": "How your reward is calculated",
  "balance.rewardStepFund": "The season fund is set in advance.",
  "balance.rewardStepBalance": "Every player's remaining carats are recorded when the season ends.",
  "balance.rewardStepShare": "The fund is shared in proportion to those balances: a larger share of carats earns a larger share of the fund.",
  "balance.estimateChanges": "The estimate can rise or fall. Your final result depends on your activity and every other player's balance.",
  "balance.exact": "Exact value",
  "balance.tapYield": "Per tap",
  "balance.seasonRule": "Your remaining carat balance counts at the end of the season. Carats spent on upgrades do not enter the distribution, and unfinished matches are settled first.",
  "workshop.kicker": "Production house",
  "workshop.lead": "Strengthen taps and passive production",
  "workshop.balance": "Balance",
  "workshop.power": "Power",
  "workshop.stageProgress": "Stage {stage} of 4",
  "workshop.stage.1": "Hand faceting",
  "workshop.stage.2": "Living circuit",
  "workshop.stage.3": "Prismatic drive",
  "workshop.stage.4": "Kinetic atelier",
  "workshop.appearance": "Workshop appearance",
  "workshop.appearanceA11y": "Appearance {stage}: {name}",
  "workshop.mastery": "{level} of {total} upgrades",
  "workshop.appearanceStepsOne": "{count} more upgrade until the next appearance",
  "workshop.appearanceStepsFew": "{count} more upgrades until the next appearance",
  "workshop.appearanceStepsMany": "{count} more upgrades until the next appearance",
  "workshop.appearanceComplete": "All appearances unlocked",
  "workshop.upgradesTitle": "Upgrades",
  "workshop.consoleTitle": "Choose a direction",
  "workshop.consoleLead": "Develop production, tap power, and energy reserve",
  "workshop.masteryA11y": "Workshop development progress",
  "workshop.precision.name": "Resonance cutter",
  "workshop.precision.body": "Strengthens every tap",
  "workshop.mechanical.name": "Faceting circuit",
  "workshop.mechanical.body": "Produces carats without taps",
  "workshop.current": "Current",
  "workshop.next": "Next",
  "workshop.branchLevel": "Level {level} of {max}",
  "workshop.levelRoute": "Level progress",
  "workshop.max": "Branch mastered for this season",
  "workshop.coreLevels": "Core development — up to level {level}",
  "workshop.masterLevels": "Advanced mastery · paid in carats",
  "workshop.launchMechanicalAction": "Start circuit",
  "workshop.upgradeMechanicalAction": "Upgrade circuit",
  "workshop.upgradePrecisionAction": "Upgrade cutter",
  "workshop.detailsFor": "Details: {name}",
  "workshop.shortfall": "Need {value} more",
  "workshop.tapEffect": "+{value} per tap",
  "workshop.passiveEffect": "+{value}",
  "workshop.unitPerTap": "carats per tap",
  "workshop.unitPerSecond": "carats/s",
  "workshop.effectComparisonA11y": "Current {current}; after the upgrade {next}",
  "workshop.appearanceWillChange": "The workshop changes appearance after this upgrade",
  "workshop.productionSpeed": "Production speed",
  "workshop.tapStrength": "Tap strength",
  "workshop.sheetCost": "Price",
  "workshop.sheetGainTap": "Tap gain",
  "workshop.sheetGainPassive": "Speed gain",
  "workshop.precision.sheet": "The cutter directs light onto the facets and strengthens every confirmed tap",
  "workshop.mechanical.sheet": "The circuit produces carats while the workshop runs without your taps",
  "energy.kicker": "Energy circuit",
  "energy.title": "Faceting reserve",
  "energy.lead": "Energy is spent only on taps and returns over time",
  "energy.reserve": "Energy",
  "energy.runtimeLabel": "Crystal reservoir",
  "energy.open": "Open energy reserve",
  "energy.full": "Fully charged",
  "energy.fullBody": "The reservoir is ready for faceting",
  "energy.empty": "Reserve depleted",
  "energy.synchronizing": "Saving taps…",
  "energy.next": "+1 in {seconds}s",
  "energy.level": "Level {level} of {max}",
  "energy.capacityName": "Crystal reservoir",
  "energy.capacityBody": "Increases the energy reserve",
  "energy.capacityUnit": "energy",
  "energy.capacityValue": "{value} energy",
  "energy.recoveryName": "Recovery flow",
  "energy.recoveryBody": "Increases the recovery rate",
  "energy.recoveryUnit": "energy/s",
  "energy.recoveryRateValue": "{value} energy per second",
  "energy.secondsValue": "1 every {value}s",
  "energy.changeA11y": "Current {current}, after upgrade {next}",
  "energy.max": "Maximum level",
  "energy.upgradeAction": "Upgrade",
  "energy.upgradeCapacityAction": "Upgrade reservoir",
  "energy.upgradeRecoveryAction": "Accelerate flow",
  "energy.refillsLeft": "Quick charges: {count}",
  "energy.sheetTitle": "Restore energy",
  "energy.sheetLead": "The reservoir immediately gains {value} energy",
  "energy.recoveryRate": "Recovery",
  "energy.refillAmount": "Energy added",
  "energy.today": "Left today",
  "energy.refillAction": "Charge now",
  "energy.limitTitle": "No quick charges left today",
  "energy.limitBody": "Energy will keep recovering on its own",
  "hall.kicker": "Season collection",
  "hall.lead": "Goals today, trophies forever",
  "hall.dailySeal": "Daily seal",
  "hall.goalsDone": "{current} of 3 goals",
  "hall.dailyReward": "Daily reward",
  "hall.claimDaily": "Claim {value}",
  "hall.dailyClaimed": "Reward claimed",
  "status.rewardAlreadyClaimed": "This reward has already been claimed",
  "hall.taskTaps": "Steady hand",
  "hall.taskTapsBody": "Make {target} taps",
  "hall.taskPrimary": "Shift output",
  "hall.taskPrimaryBody": "Earn {target} carats through faceting and the workshop",
  "hall.taskPassive": "Workshop heart",
  "hall.taskPassiveBody": "Receive {target} carats from the workshop",
  "hall.dailyKicker": "Three trials",
  "hall.dailyTitle": "Master's route",
  "hall.dailyLead": "Complete all three trials and open the Daily Seal yourself",
  "hall.untilReset": "Refreshes in",
  "hall.resetClock": "{hours} h {minutes} min",
  "hall.resetSoon": "Very soon",
  "hall.trialNumber": "Trial {number}",
  "hall.dailyForced": "for everyone",
  "hall.dailyPriority": "important today",
  "hall.openChannel": "Open channel",
  "hall.openChat": "Open chat",
  "hall.checkMembership": "Check",
  "hall.daily.tap-light-touch.name": "Light cut",
  "hall.daily.tap-light-touch.body": "Make {target} confirmed taps",
  "hall.daily.tap-steady-hand.name": "Steady rhythm",
  "hall.daily.tap-steady-hand.body": "Make {target} confirmed taps",
  "hall.daily.tap-precision.name": "Steady hand",
  "hall.daily.tap-precision.body": "Make {target} confirmed taps",
  "hall.daily.tap-clear-facet.name": "Clear facet",
  "hall.daily.tap-clear-facet.body": "Make {target} confirmed taps",
  "hall.daily.tap-master-tempo.name": "Master tempo",
  "hall.daily.tap-master-tempo.body": "Make {target} confirmed taps",
  "hall.daily.tap-long-cut.name": "Grand cut",
  "hall.daily.tap-long-cut.body": "Make {target} confirmed taps",
  "hall.daily.tap-royal-shift.name": "Royal faceting",
  "hall.daily.tap-royal-shift.body": "Make {target} taps",
  "hall.daily.energy-royal-cycle.name": "Kingdom charge",
  "hall.daily.energy-royal-cycle.body": "Spend {target} energy on faceting",
  "hall.daily.primary-royal-order.name": "Royal order",
  "hall.daily.primary-royal-order.body": "Produce {target} carats through faceting and the workshop",
  "hall.daily.primary-grand-caravan.name": "Grand reserve",
  "hall.daily.primary-grand-caravan.body": "Produce {target} carats through faceting and the workshop",
  "hall.daily.passive-royal-stream.name": "Kingdom flow",
  "hall.daily.passive-royal-stream.body": "Collect {target} carats from passive production",
  "hall.daily.passive-grand-reserve.name": "Workshop treasures",
  "hall.daily.passive-grand-reserve.body": "Collect {target} carats from passive production",
  "hall.daily.arena-royal-series.name": "Royal series",
  "hall.daily.arena-royal-series.body": "Play {target} arena matches against a player or guardian",
  "hall.daily.arena-double-victory.name": "Double victory",
  "hall.daily.arena-double-victory.body": "Win {target} arena matches against a player or guardian",
  "hall.daily.energy-deep-cut.name": "Deep cut",
  "hall.daily.energy-deep-cut.body": "Spend {target} energy on faceting",
  "hall.daily.energy-full-cycle.name": "Full charge",
  "hall.daily.energy-full-cycle.body": "Spend {target} energy on faceting",
  "hall.daily.primary-first-shift.name": "First shift",
  "hall.daily.primary-first-shift.body": "Produce {target} carats through faceting and the workshop",
  "hall.daily.primary-bright-shift.name": "Bright shift",
  "hall.daily.primary-bright-shift.body": "Produce {target} carats through faceting and the workshop",
  "hall.daily.primary-full-shift.name": "Full shift",
  "hall.daily.primary-full-shift.body": "Produce {target} carats through faceting and the workshop",
  "hall.daily.primary-strong-shift.name": "Strong shift",
  "hall.daily.primary-strong-shift.body": "Produce {target} carats through faceting and the workshop",
  "hall.daily.primary-master-shift.name": "Master shift",
  "hall.daily.primary-master-shift.body": "Produce {target} carats through faceting and the workshop",
  "hall.daily.primary-grand-order.name": "Grand order",
  "hall.daily.primary-grand-order.body": "Produce {target} carats through faceting and the workshop",
  "hall.daily.passive-quiet-current.name": "Quiet current",
  "hall.daily.passive-quiet-current.body": "Receive {target} carats from mechanisms",
  "hall.daily.passive-crystal-pulse.name": "Crystal pulse",
  "hall.daily.passive-crystal-pulse.body": "Receive {target} carats from mechanisms",
  "hall.daily.passive-light-stream.name": "Light stream",
  "hall.daily.passive-light-stream.body": "Receive {target} carats from mechanisms",
  "hall.daily.passive-engine-room.name": "Engine room",
  "hall.daily.passive-engine-room.body": "Receive {target} carats from mechanisms",
  "hall.daily.passive-full-vault.name": "Full vault",
  "hall.daily.passive-full-vault.body": "Receive {target} carats from mechanisms",
  "hall.daily.passive-cascade.name": "Carat cascade",
  "hall.daily.passive-cascade.body": "Receive {target} carats from mechanisms",
  "hall.daily.offline-return.name": "Maker's return",
  "hall.daily.offline-return.body": "Collect workshop output after a break",
  "hall.daily.offline-vault.name": "Double collection",
  "hall.daily.offline-vault.body": "Collect workshop output twice after a break",
  "hall.daily.return-second-session.name": "Back to the kingdom",
  "hall.daily.return-second-session.body": "Stay away for {minutes} min, then return. Opening the game starts the wait again",
  "hall.daily.arena-first-duel.name": "First duel",
  "hall.daily.arena-first-duel.body": "Finish {target} Arena match",
  "hall.daily.arena-double-duel.name": "Three duels",
  "hall.daily.arena-double-duel.body": "Finish {target} Arena matches",
  "hall.daily.arena-first-win.name": "Arena victory",
  "hall.daily.arena-first-win.body": "Win {target} Arena match",
  "hall.daily.arena-match-series.name": "Two duels",
  "hall.daily.arena-match-series.body": "Finish {target} Arena matches",
  "hall.daily.upgrade-workshop.name": "New mechanism",
  "hall.daily.upgrade-workshop.body": "Upgrade the workshop {target} time(s)",
  "hall.daily.upgrade-workshop-double.name": "Double reinforcement",
  "hall.daily.upgrade-workshop-double.body": "Upgrade the workshop {target} times",
  "hall.daily.venture-tap-echo.name": "Faceting echo",
  "hall.daily.venture-tap-echo.body": "Make another {target} confirmed taps",
  "hall.daily.venture-primary-spark.name": "Quarter spark",
  "hall.daily.venture-primary-spark.body": "Produce {target} carats by any method",
  "hall.daily.invite-master.name": "New maker",
  "hall.daily.invite-master.body": "Invite {target} new participant",
  "hall.daily.join-channel.name": "Quarter herald",
  "hall.daily.join-channel.body": "Subscribe to the channel to complete this route",
  "hall.daily.join-chat.name": "Makers council",
  "hall.daily.join-chat.body": "Join the chat to complete this route",
  "hall.daily.generic.name": "Daily task",
  "hall.seasonTask.generic.name": "Season task",
  "hall.task.metric.confirmed-taps": "Make {target} confirmed taps",
  "hall.task.metric.primary-produced": "Produce {target} carats by any method",
  "hall.task.metric.passive-produced": "Receive {target} carats from your mechanisms",
  "hall.task.metric.energy-spent": "Spend {target} energy on faceting",
  "hall.task.metric.offline-collections": "Collect workshop output {target} times",
  "hall.task.metric.return-visits": "Return to the game {target} times after a break",
  "hall.task.metric.upgrade-purchases": "Buy {target} upgrades. Your free starting level is not a purchase",
  "hall.task.metric.arena-matches": "Complete {target} matches",
  "hall.task.metric.arena-wins": "Win {target} Arena matches",
  "hall.task.metric.pvp-matches": "Finish {target} Arena matches against players or the Guardian",
  "hall.task.metric.daily-routes-claimed": "Claim the full daily reward on {target} different game days. They do not need to be consecutive",
  "hall.task.metric.active-invites": "Invite {target} active makers",
  "hall.task.metric.confirmed-invites": "Invite {target} new participants",
  "hall.task.metric.channel-membership": "Remain subscribed to the community channel",
  "hall.task.metric.chat-membership": "Remain in the community chat",
  "hall.streakTitle": "Route streak",
  "hall.streakDays": "{count} days in a row",
  "hall.streakNext": "Day {day} bonus — {value}",
  "hall.streakComplete": "Every streak reward is unlocked",
  "hall.streakKicker": "Consistency rewards",
  "hall.streakSheetLead": "Claim the daily reward without missing a day: every next day awards more carats.",
  "hall.streakNextReward": "Day {day} reward",
  "hall.streakCalendarA11y": "Thirty-day streak reward calendar",
  "hall.streakMilestoneA11y": "Extra milestone bonus",
  "hall.streakRuleTitle": "Claim the reward on time",
  "hall.streakRuleBody": " Missing a day or forgetting to press Claim resets the streak.",
  "hall.streakContinue": "Continue the route",
  "hall.portalTodayMeta": "{current} of 3 complete",
  "hall.portalCollectionMeta": "{count} collected",
  "hall.portalSeasonMeta": "Ranking and fund",
  "hall.portalDailyReady": "Daily reward ready",
  "hall.portalAchievementsReady": "Signs ready: {count}",
  "hall.portalSeasonReady": "Season reward ready",
  "hall.portalReadyBadge": "Rewards ready: {count}",
  "hall.rewardStored": "The carats are already in your balance",
  "hall.rewardReady": "The seal is open — your reward is ready",
  "hall.rewardRemaining": "Still to complete: {count}",
  "hall.rewardNextTasks": "Still to complete: {tasks}",
  "hall.showRemainingTask": "View unfinished task",
  "hall.progressValue": "{current} of {target}",
  "hall.filterAll": "All",
  "hall.filterCraft": "Faceting",
  "hall.filterSeason": "Season",
  "hall.filterFriends": "Club",
  "hall.categoryCraft": "Craft",
  "hall.categorySeason": "Season path",
  "hall.categoryFriends": "Makers club",
  "hall.vaultKicker": "Collectible relics",
  "hall.vaultTitle": "Master collection",
  "hall.collectionCount": "{current} of {total} collected",
  "hall.achievement.first-spark.name": "First spark",
  "hall.achievement.first-spark.body": "Make 10 confirmed taps",
  "hall.achievement.living-facet.name": "Living facet",
  "hall.achievement.living-facet.body": "Upgrade the Faceting Circuit to level 2",
  "hall.achievement.master-rhythm.name": "Master rhythm",
  "hall.achievement.master-rhythm.body": "Make 100 confirmed taps",
  "hall.achievement.light-architect.name": "Architect of light",
  "hall.achievement.light-architect.body": "Reach workshop stage 3",
  "hall.achievement.makers-circle.name": "Makers circle",
  "hall.achievement.makers-circle.body": "Build a team of 3 makers",
  "hall.achievement.perfect-facet.name": "Perfect facet",
  "hall.achievement.perfect-facet.body": "Upgrade the resonance cutter to level 5",
  "hall.achievement.crystal-reserve.name": "Crystal reserve",
  "hall.achievement.crystal-reserve.body": "Upgrade the crystal reservoir to level 3",
  "hall.achievement.silent-current.name": "Silent current",
  "hall.achievement.silent-current.body": "Produce 100,000 carats passively",
  "hall.achievement.arena-guardian.name": "Arena guardian",
  "hall.achievement.arena-guardian.body": "Win 10 Arena matches",
  "hall.achievement.season-one-participant.name": "Season One pioneer",
  "hall.achievement.season-one-participant.body": "Make at least one confirmed tap during Season One",
  "hall.achievement.season-two-participant.name": "Kingdom roads",
  "hall.achievement.season-two-participant.body": "Season Two participation badge. Awarded after the season ends for making at least one tap.",
  "hall.achievement.streak-seven.name": "Week of light",
  "hall.achievement.streak-seven.body": "Claim the daily reward for 7 days in a row",
  "hall.achievement.streak-fifteen.name": "Unbroken facet",
  "hall.achievement.streak-fifteen.body": "Claim the daily reward for 15 days in a row",
  "hall.achievement.streak-thirty.name": "Chronicle of mastery",
  "hall.achievement.streak-thirty.body": "Complete the daily route on all 30 days of the season",
  "hall.achievement.chain-conqueror.name": "Path conqueror",
  "hall.achievement.chain-conqueror.body": "Complete all 6 main season challenge chains",
  "hall.achievement.branch-master.name": "Peak of craft",
  "hall.achievement.branch-master.body": "Complete the core levels of one workshop branch",
  "hall.achievement.workshop-sovereign.name": "Workshop sovereign",
  "hall.achievement.workshop-sovereign.body": "Complete the core levels of all 4 branches. Additional levels are not required",
  "hall.achievement.pvp-first-win.name": "First duel",
  "hall.achievement.pvp-first-win.body": "Win your first Arena match against a player or the Guardian",
  "hall.achievement.pvp-ten-wins.name": "Arena scourge",
  "hall.achievement.pvp-ten-wins.body": "Win 10 Arena matches against players or the Guardian",
  "hall.achievement.arena-ten-matches.name": "Ten duels",
  "hall.achievement.arena-ten-matches.body": "Complete 10 Arena matches",
  "hall.achievement.arena-fifty-matches.name": "Arena legend",
  "hall.achievement.arena-fifty-matches.body": "Complete 50 Arena matches",
  "hall.achievement.active-friend-one.name": "First alliance",
  "hall.achievement.active-friend-one.body": "Personally invite one maker who produces {threshold} this season",
  "hall.achievement.active-friend-three.name": "Triune alliance",
  "hall.achievement.active-friend-three.body": "Personally invite 3 makers who each produce {threshold} this season",
  "hall.achievement.active-friend-ten.name": "Council of makers",
  "hall.achievement.active-friend-ten.body": "Personally invite 10 makers who each produce {threshold} this season",
  "hall.achievement.top-ten-percent.name": "Premier league",
  "hall.achievement.top-ten-percent.body": "Finish the season among the top 10% of players",
  "hall.achievement.top-hundred.name": "Top hundred",
  "hall.achievement.top-hundred.body": "Finish the season in the top 100",
  "hall.achievement.top-ten.name": "Kingdom top ten",
  "hall.achievement.top-ten.body": "Finish the season in the top 10",
  "hall.achievement.season-champion.name": "Season crown",
  "hall.achievement.season-champion.body": "Take first place at the end of the season",
  "hall.finalRankPending": "Unlocks after the season results",
  "hall.rankProgress": "Place {current} · target: top {target}",
  "hall.percentileProgress": "Currently top {current}% · target: top {target}%",
  "hall.ready": "Ready to claim",
  "hall.claimed": "In collection",
  "hall.claim": "Claim badge",
  "hall.collectibleLocked": "Not collected yet",
  "hall.collectibleShopStatus": "Available in the shop",
  "hall.collectibleOpenShop": "Open shop",
  "hall.collectibleOpenShopA11y": "Open skins in the shop: {name}",
  "hall.collectibleSeasonZeroStatus": "After the season ends",
  "hall.collectibleSeasonZeroBody": "Make at least one confirmed tap. The signet will appear after Season Zero ends.",
  "hall.claimTask": "Claim",
  "hall.taskReward": "Reward",
  "hall.finalCheck": "Checked at the finale",
  "hall.seasonBalance": "Your balance",
  "hall.seasonPlace": "Current place",
  "hall.seasonShare": "Your share",
  "hall.seasonEstimate": "Reward estimate",
  "hall.seasonEstimateNote": "The estimate changes with every player's balance",
  "hall.projectionPreparingKicker": "The treasury is gathering pace",
  "hall.projectionPreparing": "Estimate unlocks in {time}",
  "hall.projectionPreparingBody": "Your carats already count. Rank, fund share, and the USDT estimate will appear once the season's opening results become meaningful.",
  "hall.distributionIn": "Distribution in",
  "hall.seasonStartsIn": "Season starts in",
  "hall.claimClosesIn": "Reward claim closes in",
  "hall.countdownDays": "d",
  "hall.countdownHours": "h",
  "hall.countdownMinutes": "m",
  "hall.prizeFund": "Prize fund",
  "hall.prizeFundNote": "Current season fund",
  "hall.tonPrize.kicker": "Leaderboard prizes",
  "hall.tonPrize.title": "500 USDT to wallets",
  "hall.tonPrize.body": "Players finishing in positions 1–6 receive real USDT on TON in addition to the season reward.",
  "hall.tonPrize.network": "Paid on TON",
  "hall.tonPrize.place": "No. {place}",
  "hall.tonPrize.details": "How to receive",
  "hall.tonPrize.rule": "Places are locked from carat balances in the final snapshot.",
  "hall.tonPrize.sheetKicker": "Separate prize pool",
  "hall.tonPrize.sheetTitle": "500 USDT for the leaders",
  "hall.tonPrize.sheetBody": "These are real USDT on TON. They are not credited to the Diamond Kingdom reward account.",
  "hall.tonPrize.stepFinal": "When the season ends, the server locks the final standings.",
  "hall.tonPrize.stepWallet": "Each winner verifies a TON wallet and requests the payout.",
  "hall.tonPrize.stepPayout": "The project sends USDT to the verified address. Winners pay no Stars or fee.",
  "hall.tonPrize.tieRule": "If players tie, the prizes for the occupied places are shared equally between them.",
  "hall.tonPrize.winnerKicker": "Your leaderboard prize",
  "hall.tonPrize.winnerTitle": "You finished No. {place}",
  "hall.tonPrize.winnerAmount": "Payout — {value}",
  "hall.tonPrize.locked": "The standings are locked. Payouts open after the final review.",
  "hall.tonPrize.walletRequired": "Verify a TON wallet to receive the prize. The button appears after the final review.",
  "hall.tonPrize.ready": "Wallet verified. You can request the payout.",
  "hall.tonPrize.processing": "Your transfer is being sent on TON.",
  "hall.tonPrize.paid": "USDT was sent to your TON wallet.",
  "hall.tonPrize.expired": "The prize collection window has closed.",
  "hall.tonPrize.failed": "The transfer did not complete. Retry becomes available after review.",
  "hall.ofParticipants": "of {count} participants",
  "hall.shareOfFund": "of the current fund",
  "hall.rankingKicker": "Nearest rivals",
  "hall.seasonScheduledHint": "The crown will awaken when the season starts",
  "hall.seasonActiveHint": "Your carat balance determines your place",
  "hall.seasonFrozenHint": "Balances are locked while results are calculated",
  "hall.seasonSettlingHint": "Final checks are running before the distribution",
  "hall.seasonClaimHint": "Time left: {window}. Claim costs {stars} Stars. Your reward will be saved to the reward account in your profile. This is a reference value of game tokens, not a USDT transfer to your wallet.",
  "hall.seasonClosedHint": "The result is saved in your profile history",
  "hall.seasonExpiredHint": "The reward expired because it was not claimed within {window}",
  "hall.seasonQuestsKicker": "Long journey",
  "hall.seasonQuestsTitle": "Season quests",
  "hall.seasonQuestsProgress": "Claimed {current} of {total}",
  "hall.communityKicker": "Final condition",
  "hall.communityTitle": "Kingdom covenant",
  "hall.communityBody": "Remain in both the channel and chat until the season ends. After the final check, 50% will be added to your balance.",
  "hall.communityBonusRate": "+50% to your balance",
  "hall.communityBonusPreview": "+{value} to your current balance",
  "hall.communityBonusApplied": "Added {value}",
  "hall.communityReady": "Channel and chat confirmed",
  "hall.communityMissing": "Still needed: {targets}",
  "hall.communityFinalCheck": "Membership is checked again when the season ends",
  "hall.communityChannelShort": "channel",
  "hall.communityChatShort": "chat",
  "hall.seasonTask.season-taps-1.name": "First rhythm",
  "hall.seasonTask.season-taps-1.body": "Make {target} confirmed taps",
  "hall.seasonTask.season-taps-2.name": "Steady rhythm",
  "hall.seasonTask.season-taps-2.body": "Make {target} confirmed taps",
  "hall.seasonTask.season-taps-3.name": "Kingdom rhythm",
  "hall.seasonTask.season-taps-3.body": "Make {target} confirmed taps",
  "hall.seasonTask.season-primary-1.name": "First treasury",
  "hall.seasonTask.season-primary-1.body": "Produce {target} carats during the season",
  "hall.seasonTask.season-primary-2.name": "Grand faceting",
  "hall.seasonTask.season-primary-2.body": "Produce {target} carats during the season",
  "hall.seasonTask.season-primary-3.name": "Royal reserve",
  "hall.seasonTask.season-primary-3.body": "Produce {target} carats during the season",
  "hall.seasonTask.season-upgrades-1.name": "Workshop foundations",
  "hall.seasonTask.season-upgrades-1.body": "Buy {target} upgrades. The free starting level is not a purchase",
  "hall.seasonTask.season-upgrades-2.name": "Architect of light",
  "hall.seasonTask.season-upgrades-2.body": "Buy {target} upgrades. The free starting level is not a purchase",
  "hall.seasonTask.season-upgrades-3.name": "Perfect workshop",
  "hall.seasonTask.season-upgrades-3.body": "Buy {target} upgrades. The free starting level is not a purchase",
  "hall.seasonTask.season-arena-1.name": "First tournament",
  "hall.seasonTask.season-arena-1.body": "Finish {target} matches",
  "hall.seasonTask.season-arena-2.name": "Voice of the Arena",
  "hall.seasonTask.season-arena-2.body": "Finish {target} matches",
  "hall.seasonTask.season-arena-3.name": "Arena legend",
  "hall.seasonTask.season-arena-3.body": "Finish {target} matches",
  "hall.seasonTask.season-routes-1.name": "Steady path",
  "hall.seasonTask.season-routes-1.body": "Claim the full daily reward on {target} different days. They do not need to be consecutive",
  "hall.seasonTask.season-routes-2.name": "Maker's resolve",
  "hall.seasonTask.season-routes-2.body": "Claim the full daily reward on {target} different days. They do not need to be consecutive",
  "hall.seasonTask.season-routes-3.name": "Monthly chronicle",
  "hall.seasonTask.season-routes-3.body": "Claim the full daily reward on {target} different days. They do not need to be consecutive",
  "hall.seasonTask.season-routes-4.name": "Flawless streak",
  "hall.seasonTask.season-routes-4.body": "Claim the full daily reward on {target} different days this season",
  "hall.seasonTask.season-friends-1.name": "First ally",
  "hall.seasonTask.season-friends-1.body": "Personally invite {target} maker who produces {threshold} through taps and the workshop this season. Friends of friends do not count for this task",
  "hall.seasonTask.season-friends-2.name": "Makers circle",
  "hall.seasonTask.season-friends-2.body": "Personally invite {target} makers who each produce {threshold} through taps and the workshop this season. Friends of friends do not count for this task",
  "hall.seasonTask.season-friends-3.name": "Facet guild",
  "hall.seasonTask.season-friends-3.body": "Personally invite {target} makers who each produce {threshold} through taps and the workshop this season. Friends of friends do not count for this task",
  "hall.seasonTask.season-channel.name": "Quarter chronicle",
  "hall.seasonTask.season-channel.body": "Remain in the channel through the season finale",
  "hall.seasonTask.season-chat.name": "Makers council",
  "hall.seasonTask.season-chat.body": "Remain in the chat through the season finale",
  "hall.seasonRuleTitle": "What counts",
  "hall.previousSeason": "Previous season",
  "hall.previousResult": "Best place — No. {place}",
  "hall.noPreviousResult": "Your result appears after the season ends",
  "hall.rankAfterFirstCarat": "After your first carat",
  "hall.worldToday": "Daily trials",
  "hall.worldCollection": "Relic vault",
  "hall.worldSeason": "Season chronicle",
  "hall.heroDailyProgress": "Complete: {current} of 3",
  "hall.heroDailyClaimed": "Daily Seal complete",
  "hall.heroDailyReward": "Inside: {value}",
  "hall.collectionPermanent": "Badges and titles remain after the season",
  "hall.seasonHeroRule": "Your place depends on your carat balance",
  "onboarding.keeperName": "Facet Keeper",
  "onboarding.welcomeKicker": "First shift",
  "onboarding.welcomeTitle": "Welcome to the Facet Quarter",
  "onboarding.welcomeBody": "Mine carats and grow your share of the season prize fund.",
  "onboarding.seasonFundLabel": "Season prize fund",
  "onboarding.seasonFund": "The current prize fund is {fund}",
  "onboarding.seasonTime": "Distribution in {time}",
  "onboarding.seasonRule": "The more carats you hold at the snapshot, the larger your share of the fund.",
  "onboarding.seasonNext": "A new season begins after the snapshot. Production upgrades reset, while badges and skins stay with you.",
  "onboarding.begin": "Start tutorial",
  "onboarding.skip": "Skip",
  "onboarding.tapTitle": "Awaken the diamond",
  "onboarding.tapBody": "Make 10 taps. Each confirmed tap earns 10 carats.",
  "onboarding.tapProgress": "{current} of {target} taps",
  "onboarding.mapTitle": "Open the map",
  "onboarding.mapBody": "The map connects the Workshop, Trophy Hall, Makers Club and Arena.",
  "onboarding.mapAction": "Open map",
  "onboarding.workshopTitle": "Start the workshop",
  "onboarding.workshopBody": "Begin with the Faceting Circuit — it earns carats even when you are not tapping.",
  "onboarding.workshopAction": "Enter Workshop",
  "onboarding.upgradeTitle": "Start your first mechanism",
  "onboarding.upgradeBody": "Tap the highlighted button — the Faceting Circuit will start earning carats for you.",
  "onboarding.upgradeAction": "Start Circuit",
  "onboarding.passiveTitle": "Your first batch is ready",
  "onboarding.passiveBody": "Claim {value} carats. The Faceting Circuit will keep producing them for you.",
  "onboarding.passiveClaim": "Claim {value} carats",
  "onboarding.passiveProgress": "Earned {current} of {target} carats",
  "onboarding.trophyTitle": "Track your progress",
  "onboarding.trophyBody": "The Trophy Hall holds daily goals, achievements and your season share.",
  "onboarding.trophyAction": "Open Trophy Hall",
  "onboarding.trophyOverviewTitle": "Goals, badges and season",
  "onboarding.trophyOverviewBody": "Today rewards the daily route. Hall of Fame keeps unlocked badges, while Season shows your share of the fund.",
  "onboarding.trophyOverviewAction": "Show season",
  "onboarding.seasonTitle": "Open the season chronicle",
  "onboarding.seasonBody": "Choose Season to see the snapshot timer and the current season prize fund.",
  "onboarding.seasonAction": "Show season",
  "onboarding.seasonOverviewTitle": "The snapshot ends the season",
  "onboarding.seasonOverviewBody": "At the shown time, the prize fund is shared in proportion to every player's carat balance. A larger balance at the snapshot means a larger share.",
  "onboarding.next": "Continue",
  "onboarding.seasonReturnTitle": "Return to the map",
  "onboarding.seasonReturnBody": "You can check the season at any time. The map takes you back to the Quarter's other locations.",
  "onboarding.returnMapAction": "Return to map",
  "onboarding.clubTitle": "Gather your circle",
  "onboarding.clubBody": "The Club shows invited friends and the carats earned from their active faceting.",
  "onboarding.clubAction": "Open Makers Club",
  "onboarding.clubOverviewTitle": "How your circle works",
  "onboarding.clubOverviewBody": "You receive {levelOne} of carats friends produce by tapping and in their workshop, plus {levelTwo} from their friends. Arena and season rewards do not count.",
  "onboarding.clubOverviewAction": "Show invitation",
  "onboarding.clubLinkTitle": "Invite a maker",
  "onboarding.clubLinkBody": "Your personal link is ready. Choose Copy and send it to a friend; they join your circle after opening the game.",
  "onboarding.clubLinkAction": "Copy invitation link",
  "onboarding.clubReturnTitle": "Your circle stays close",
  "onboarding.clubReturnBody": "Invited makers and earned carats stay visible here. Return to the map to visit the Arena.",
  "onboarding.arenaTitle": "Test your craft",
  "onboarding.arenaBody": "In the Arena, carats move between players: the winner takes the bank and no new currency is created.",
  "onboarding.arenaAction": "Open Arena",
  "onboarding.arenaOverviewTitle": "Choose a challenge",
  "onboarding.arenaOverviewBody": "The Arena holds several games. Before a match, you see its rules and stake; winnings move from your opponent's balance.",
  "onboarding.arenaOverviewAction": "Show games",
  "onboarding.arenaGameTitle": "Crystal Penalty",
  "onboarding.arenaGameBody": "The first game has three series of shots and saves. Rules and stake appear before the match; you can play after the tutorial.",
  "onboarding.arenaGameTarget": "Crystal Penalty game card",
  "onboarding.arenaGameAction": "Finish the tour",
  "onboarding.arenaReturnTitle": "Ready for a match",
  "onboarding.arenaReturnBody": "The stake, rules and opponent search are here. You can play later—the tutorial is complete.",
  "onboarding.arenaReturnAction": "Finish tutorial",
  "onboarding.completeKicker": "Route complete",
  "onboarding.completeTitle": "The Quarter is open",
  "onboarding.completeBody": "You're ready: mine carats, develop the Workshop and grow your estimated season reward.",
  "onboarding.finish": "Start mining",
  "onboarding.recover": "Continue tutorial",
  "club.kicker": "Quarter guild",
  "club.lead": "Makers at one table",
  "club.body": "Your friend keeps everything. You receive {first} from friends and {second} from their friends after each produces {threshold}",
  "club.heroLabel": "Your circle",
  "club.heroMembers": "In the club: {count}",
  "club.emptyHeroLabel": "Open table",
  "club.emptyHeroLead": "The club awaits its makers",
  "club.emptyHeroBody": "Invite your first friend",
  "club.reward": "Credited to you",
  "club.active": "In the club",
  "club.produced": "Friends produced",
  "club.nextMilestone": "{count} more for the next club badge",
  "club.filterAll": "All",
  "club.filterA11y": "Filter makers",
  "club.searchLabel": "Find a maker by name",
  "club.searchPlaceholder": "Find a maker…",
  "club.showing": "Showing {from}–{to} of {total}",
  "club.paginationA11y": "Maker list pages",
  "club.previousPage": "Previous page",
  "club.nextPage": "Next page",
  "club.pageA11y": "Page {page}",
  "club.noResultsTitle": "Maker not found",
  "club.noResultsBody": "Check the name or choose another circle",
  "club.clearSearch": "Clear search",
  "club.inviteTitle": "Club link",
  "club.inviteBody": "Your friend appears here after their first visit",
  "club.copyLink": "Copy link",
  "club.memberContribution": "Produced {value}",
  "club.memberProduced": "Produced",
  "club.memberReward": "You receive",
  "club.emptyLead": "No one is in the club yet",
  "club.emptyBody": "Invite a friend. They appear at the table after their first visit",
  "club.worldKicker": "Quarter guild",
  "club.worldTitle": "Your circle is gaining strength",
  "club.worldEmptyTitle": "Light the first sign",
  "club.worldEmptyBody": "Your first maker appears here after joining",
  "club.worldProgress": "{count} makers · {remaining} more for a new badge",
  "club.worldReady": "{count} makers · a new club badge is open",
  "club.inviteMaster": "Invite a maker",
  "club.filterAllV2": "Whole club",
  "club.filterNearCompact": "Near",
  "club.filterFarCompact": "Far",
  "club.filterNear": "Near circle",
  "club.filterFar": "Far circle",
  "club.filterCount": "{count} makers",
  "club.rewardKicker": "Club strength",
  "club.rewardTitle": "Club reward",
  "club.rewardNote": "Already credited to your balance",
  "club.members": "Makers",
  "club.teamProduced": "Produced by makers",
  "club.registrationReward": "Registrations",
  "club.productionReward": "Friends’ production",
  "club.milestone": "Club badge",
  "club.milestoneProgress": "{current} of {target}",
  "club.milestoneRemaining": "Invite {count} more makers",
  "club.milestoneReady": "A new badge awaits in the Trophy Hall",
  "club.oathKicker": "Two circles",
  "club.oathTitle": "What {first} and {second} mean",
  "club.nearBody": "{rate} of production by a friend you invited after their first {threshold}",
  "club.farBody": "{rate} of production by your friend’s friend after their first {threshold}",
  "club.rateDetails": "Show calculation",
  "club.nearRateA11y": "Near Circle: {rate} of production by a friend you invited after their first {threshold}. Show calculation",
  "club.farRateA11y": "Far Circle: {rate} of production by your friend’s friend after their first {threshold}. Show calculation",
  "club.thresholdRule": "Your friend keeps every carat. The club credits your reward separately",
  "club.taskRule": "Tasks count your personal invites — the near circle. Friends of friends earn you rewards, but do not increase task progress",
  "club.memberTaskCounted": "Counts towards tasks",
  "club.memberFarReward": "Rewards only, not task progress",
  "club.memberNotInSeason": "Invited, but has not joined this season yet",
  "club.memberInSeason": "Playing this season. {value} until active",
  "club.registerKicker": "Makers register",
  "club.registerTitle": "Your makers",
  "club.registerTotal": "{count} total",
  "club.searchPlaceholderV2": "Maker name",
  "club.memberThresholdA11y": "{name} progress toward club rewards",
  "club.memberEarning": "Earning rewards",
  "club.memberRemaining": "{value} more to unlock rewards",
  "club.memberProducedV2": "Produced this season",
  "club.memberRewardV2": "For you",
  "club.noResultsTitleV2": "No maker found",
  "club.noResultsBodyV2": "Change the name or open the whole club",
  "club.clearSearchV2": "Show the whole club",
  "club.emptyLeadV2": "The register awaits its first name",
  "club.emptyBodyV2": "Send an invitation. The maker appears after joining",
  "club.inviteGateKicker": "Club gate",
  "club.inviteGateTitle": "Open the way for a new maker",
  "club.inviteGateBody": "Send your personal link. Your friend appears in the Near Circle after joining",
  "club.inviteLinkA11y": "Personal invitation link",
  "club.inviteShare": "Share invitation",
  "club.inviteCopy": "Copy key",
  "club.inviteShared": "Invitation sent",
  "club.inviteCopied": "Key copied",
  "profile.kicker": "Maker profile",
  "profile.rank": "Best place",
  "profile.currentSeason": "{season} in progress",
  "profile.seasons": "Seasons",
  "profile.trophies": "Trophies",
  "profile.collection": "Collection",
  "profile.collectionHint": "Trophies and titles remain after the season changes",
  "profile.selectedTrophy": "Selected badge",
  "profile.chooseTrophy": "Select title",
  "profile.noTitle": "No title selected yet",
  "profile.lockedTrophy": "Unlock in the Trophy Hall",
  "profile.preferences": "Feel",
  "profile.musicHint": "Background music across every section",
  "profile.effectsHint": "Taps and mechanisms",
  "profile.vibrationHint": "Feedback for actions",
  "profile.reducedMotionHint": "Calmer transitions and effects",
  "profile.help": "Help",
  "profile.rules": "How the season works",
  "profile.support": "Contact support",
  "profile.client": "Diamond Kingdom · {version}",
  "profile.settingsHintV2": "Sound and motion settings are saved on this device",
  "profile.rewardAccount": "Diamond Kingdom reward account",
  "profile.rewardAccountHint": "All received season rewards in one place",
  "profile.plannedTokens": "At the planned price: {value} tokens",
  "profile.openHall": "Open Hall of Fame",
  "rewardAccount.kicker": "Royal treasury",
  "rewardAccount.title": "Your reward account",
  "rewardAccount.body": "Your claimed season rewards and support from your mentor are kept here. You can join the next season without paying for the previous one.",
  "rewardAccount.balanceLabel": "Accumulated reference value",
  "rewardAccount.balanceHint": "Claimed rewards and received transfers, less spending",
  "rewardAccount.historyKicker": "Treasury chronicle",
  "rewardAccount.historyTitle": "Reward history",
  "rewardAccount.emptyTitle": "The treasury awaits its first reward",
  "rewardAccount.emptyBody": "Claim a season reward before its deadline to add its value and history entry here.",
  "rewardAccount.entrySeason": "Reward received · {season}",
  "rewardAccount.entryPartnerIn": "Support received from your mentor",
  "rewardAccount.entryPartnerOut": "Support sent to your master",
  "rewardAccount.entryWallet": "Used to claim tokens",
  "rewardAccount.entryDiamond": "Moved to the Diamond app",
  "rewardAccount.entryLpReserve": "Funds allocated to your LP position",
  "rewardAccount.entryLpRefund": "LP funds returned",
  "rewardAccount.entryLpCreated": "Personal LP position created",
  "rewardAccount.externalOperation": "Account operation",
  "rewardAccount.referenceTitle": "How the value is calculated",
  "rewardAccount.referenceRate": "Published launch price: {value}",
  "rewardAccount.referenceNote": "The amount uses the game token’s published launch price. It is a reference value, not a fixed exchange rate or promise of payment. The market price may change after launch.",
  "shop.kicker": "Vault of rarities",
  "shop.title": "Premium shop",
  "shop.open": "Open premium shop",
  "shop.openShort": "Shop",
  "shop.backToGame": "Back to game",
  "shop.lead": "Boosts, skins, and rare signets",
  "shop.reserve": "Offline time reserve",
  "shop.boosts": "Boosts",
  "shop.none": "None active",
  "shop.queued": "Queued: {count}",
  "shop.reserveAvailable": "You have {time} of extra offline production in reserve",
  "shop.boostActive": "Boost active for another {time}",
  "boost.tapActive": "Taps +{percent}%",
  "boost.tapQueued": "Boost starts in",
  "boost.perTap": "+{value} carats per tap",
  "boost.next": "Up next: {count}",
  "boost.sequential": "Boosts run one after another. Another purchase adds time, not a higher percentage.",
  "boost.passiveActive": "Passive production boosted for {time}",
  "shop.categories": "Shop categories",
  "shop.category.reserve": "Offline",
  "shop.category.booster": "Boosts",
  "shop.category.skin": "Skins",
  "shop.category.signet": "Launch",
  "shop.permanent": "All season",
  "shop.purchaseCount": "Purchases this season: {count} of {limit}",
  "shop.purchaseLimit": "Up to {limit} purchases this season",
  "shop.limitReached": "Limit used",
  "shop.limitReachedHint": "No purchases left for this season",
  "shop.endsIn": "Ends in {time}",
  "shop.opensWithSeason": "Opens when the season starts",
  "shop.finished": "Offer ended",
  "shop.featured": "Season pick",
  "shop.owned": "Owned",
  "shop.inCollection": "In collection",
  "shop.selected": "Selected",
  "shop.wear": "Equip",
  "shop.preview": "Preview",
  "shop.previewing": "Previewing",
  "shop.buy": "{stars} ⭐",
  "shop.starsNote": "Prices are shown in Telegram Stars. Boosts run in sequence, so paid time is never lost.",
  "shop.reserveNote": "Payment uses Telegram Stars. Extra hours stack and stay in reserve until they are needed.",
  "shop.collectionNote": "Payment uses Telegram Stars. Skins and signets remain in your collection permanently.",
  "shop.startGrantNote": "Each purchase recalculates the bonus from confirmed manual production only. Passive production and earlier purchases are excluded.",
  "shop.startWindow.kicker": "Launch offer",
  "shop.startWindow.title": "Royal reserve",
  "shop.startWindow.active": "Closes in · {time}",
  "shop.startWindow.upcoming": "Opens when the season starts",
  "shop.startWindow.expired": "The launch window is closed",
  "shop.startWindow.base": "Produced by taps: {value}",
  "shop.startWindow.grantNow": "Added now",
  "shop.startWindow.grantEmpty": "Produce some carats by tapping first",
  "shop.offer.season-start-taps-10.name": "Launch impulse · +10%",
  "shop.offer.season-start-taps-10.body": "10% of all carats produced by confirmed taps at purchase time",
  "shop.offer.season-start-taps-30.name": "Royal growth · +30%",
  "shop.offer.season-start-taps-30.body": "30% of all carats produced by confirmed taps at purchase time",
  "shop.offer.season-start-taps-50.name": "Grand reserve · +50%",
  "shop.offer.season-start-taps-50.body": "50% of all carats produced by confirmed taps at purchase time",
  "shop.offer.offline-reserve-starter-8h.name": "First reserve · 8 more hours",
  "shop.offer.offline-reserve-starter-8h.body": "Once per season: the workshop keeps producing for 8 more hours after the free limit.",
  "shop.offer.offline-reserve-8h.name": "8 more production hours",
  "shop.offer.offline-reserve-8h.body": "The workshop keeps producing after the free 4 hours. Time is used only while you are away.",
  "shop.offer.offline-reserve-12h.name": "12 more production hours",
  "shop.offer.offline-reserve-12h.body": "The workshop keeps producing after the free 4 hours. Time is used only while you are away.",
  "shop.offer.offline-reserve-24h.name": "24 more production hours",
  "shop.offer.offline-reserve-24h.body": "The workshop keeps producing after the free 4 hours. Time is used only while you are away.",
  "shop.offer.passive-boost-20-24h.name": "Workshop turbine",
  "shop.offer.passive-boost-20-24h.body": "+20% to your current passive rate for 24 hours",
  "shop.offer.passive-boost-20-6h.name": "Turbine spark",
  "shop.offer.passive-boost-20-6h.body": "+20% to your current passive rate for 6 hours",
  "shop.offer.tap-boost-50-30m.name": "Faceter impulse",
  "shop.offer.tap-boost-50-30m.body": "+50% to every tap for 30 minutes",
  "shop.offer.skin-aurora-prism.name": "Aurora Prism skin",
  "shop.offer.skin-aurora-prism.body": "A permanent turquoise-and-gold skin. Does not increase production",
  "shop.offer.skin-black-diamond.name": "Black Diamond",
  "shop.offer.skin-black-diamond.body": "A dark stellar cut. Stays after the season; does not increase production",
  "shop.offer.skin-solar-heart.name": "Solar Heart",
  "shop.offer.skin-solar-heart.body": "An amber-lit golden cut. A permanent skin, not a production boost",
  "shop.offer.skin-emerald-abyss.name": "Emerald Abyss",
  "shop.offer.skin-emerald-abyss.body": "A turquoise skin with fiery sparks. Stays after the season; does not increase production",
  "shop.skin.default.name": "Classic cut",
  "shop.skin.default.body": "The original diamond skin, always available",
  "shop.offer.season-01-signet.name": "First-season signet",
  "shop.offer.season-01-signet.body": "One rare signet per season, kept forever in the Hall of Fame",
  "collection.seasonZeroParticipant.name": "Season Zero participant",
  "shop.offer.generic.offline-reserve.name": "Extra production time",
  "shop.offer.generic.offline-reserve.body": "The workshop will keep producing for another {duration} after the free period.",
  "shop.offer.generic.passive-boost.name": "Workshop boost",
  "shop.offer.generic.passive-boost.body": "+{percent}% passive production for {duration}",
  "shop.offer.generic.tap-boost.name": "Faceting boost",
  "shop.offer.generic.tap-boost.body": "+{percent}% to every tap for {duration}",
  "rewardReveal.kicker": "New relic",
  "rewardReveal.saved": "Saved in the Hall of Fame",
  "rewardReveal.continue": "Continue",
  "collection.rarity.common": "Common badge",
  "collection.rarity.rare": "Rare badge",
  "collection.rarity.epic": "Epic relic",
  "collection.rarity.legendary": "Legendary relic",
  "collection.kind.achievement": "Mastery achievement",
  "collection.kind.season-signet": "Season keepsake",
  "collection.kind.cosmetic": "Permanent skin",
  "collection.source": "Source",
  "collection.received": "Received",
  "collection.source.achievement": "Achievement",
  "collection.source.legacy-achievement": "Previously earned achievement",
  "collection.source.premium-shop": "Premium shop",
  "collection.source.season-zero-participation": "Season Zero participation",
  "collection.offChain": "Stored in-game; NFT minting is not enabled yet",
  "status.networkTitle": "No connection",
  "status.musicUnavailable": "Music did not load. Check your connection and turn it on again",
  "status.networkBody": "Reconnecting automatically",
  "status.tapSyncTitle": "Saving your carats…",
  "spend.saving": "Saving your taps…",
  "spend.sending": "Processing…",
  "spend.savingBody": "Taps left to save: {count}. Your action will continue automatically. Close this window to cancel it.",
  "spend.sendingBody": "Waiting for confirmation. No need to press again.",
  "spend.stalledTitle": "Saving is taking longer",
  "spend.stalledBody": "Your taps remain on this device. Wait for them to save, then try the action again.",
  "status.tapSyncBody": "Taps are saved on your device and sent automatically",
  "status.retry": "Try again",
  "status.restored": "Connection restored. Balance updated",
  "status.partial": "Accepted taps: {accepted} of {requested}",
  "status.tapsConfirmed": "Added {value}. Balance {balance}",
  "status.offline": "Workshop produced {value}",
  "status.upgraded": "Circuit started · +{value}",
  "status.precisionUpgraded": "Resonance cutter upgraded",
  "status.precisionUpgradeBody": "Tap reward is now {value}",
  "status.mechanicalUpgraded": "Faceting circuit upgraded",
  "status.mechanicalUpgradeBody": "Production speed is now {value}",
  "status.energyCapacityUpgraded": "Reservoir upgraded",
  "status.energyCapacityBody": "Energy capacity is now {value}",
  "status.energyRecoveryUpgraded": "Recovery flow upgraded",
  "status.energyRecoveryBody": "One energy now returns every {value}s",
  "upgradeConfirm.kicker": "Confirmation",
  "upgradeConfirm.title": "Upgrade “{name}”?",
  "upgradeConfirm.body": "This unlocks level {level} of {max}",
  "upgradeConfirm.balance": "Current",
  "upgradeConfirm.cost": "Cost",
  "upgradeConfirm.after": "Remaining",
  "upgradeConfirm.note": "Carats are spent immediately. The upgrade cannot be undone",
  "upgradeConfirm.cancel": "Not now",
  "upgradeConfirm.confirm": "Confirm",
  "status.energyRefilled": "Energy restored",
  "status.energyRefilledBody": "+{value} energy · quick charges left: {count}",
  "status.energyEmpty": "Energy depleted",
  "status.energyEmptyBody": "It recovers on its own. The reservoir can charge it faster",
  "status.notEnoughHint": "Facet the diamond or wait for the Circuit to produce more",
  "offline.kicker": "Welcome back",
  "offline.title": "Your Workshop earned carats",
  "offline.body": "The Faceting Circuit kept working while you were away",
  "offline.earned": "Collected",
  "offline.duration": "Work time: {duration}",
  "offline.action": "Continue",
  "offline.loadingTitle": "The Workshop is preparing your reward",
  "offline.loadingBody": "Gathering the carats you earned…",
  "offline.loadingProgress": "Preparing reward",
  "offline.loadingError": "The reward did not open",
  "offline.loadingErrorBody": "Check your connection and try again",
  "offline.loadingRetry": "Try again",
  "help.open": "Open {section} rules",
  "help.kicker": "How it works",
  "help.seasonNote": "Spent carats do not count toward the season balance. Compare the cost with the future gain before upgrading",
  "help.workshop.title": "Workshop",
  "help.workshop.lead": "Four mechanisms control production and energy",
  "help.workshop.mechanicalTitle": "Faceting Circuit",
  "help.workshop.mechanicalLabel": "Production without taps",
  "help.workshop.mechanicalBody": "Produces carats even while the game is closed",
  "help.workshop.precisionTitle": "Resonance Cutter",
  "help.workshop.precisionLabel": "Reward per tap",
  "help.workshop.precisionBody": "Increases carats earned when you tap the diamond",
  "help.workshop.capacityTitle": "Crystal reservoir",
  "help.workshop.capacityLabel": "Energy reserve",
  "help.workshop.capacityBody": "Lets you facet longer without a break",
  "help.workshop.recoveryTitle": "Recovery flow",
  "help.workshop.recoveryLabel": "Charge speed",
  "help.workshop.recoveryBody": "Increases the energy recovery rate",
  "help.workshop.action": "Got it",
  "help.hall.title": "Trophy Hall",
  "help.hall.lead": "The hall brings together daily goals, your permanent collection, and the current season result",
  "help.hall.rule1": "Daily goals count confirmed taps, total production, and Faceting Circuit production for the current UTC day",
  "help.hall.rule2": "Claimed trophies and the selected title remain between seasons",
  "help.hall.rule3": "Your place and reward estimate depend on your carat balance at the season snapshot",
  "help.club.title": "Makers Club",
  "help.club.lead": "The club rewards real activity by invited players without taking away their carats",
  "help.club.rule1": "Your friend keeps all production. Once they produce their first {threshold}, you separately receive {first} from their following taps and workshop production",
  "help.club.rule2": "Friends of friends earn you {second} under the same rule and only after their own threshold",
  "help.club.rule3": "PvP, club rewards, tasks, achievements, season payouts, refunds, and administrative corrections do not count",
  "help.club.rule4": "Search works by name. Filters separate friends from friends of friends; the roster is paginated",
  "help.club.note": "Club rewards do not reduce the friend’s balance and do not generate more club rewards",
  "help.club.kickerV2": "Club reward",
  "help.club.titleV2": "How {first} and {second} work",
  "help.club.leadV2": "A confirmed friend registration grants a one-time reward. Production shares start after {threshold}",
  "help.club.registration": "Each confirmed first-line registration grants {value}",
  "help.club.nearBody": "You invited the friend. After their first {threshold}, the club credits you {rate} of their later production",
  "help.club.farBody": "Your friend invited the player. After their first {threshold}, the club credits you {rate} of their later production",
  "help.club.exampleKicker": "Calculation example",
  "help.club.exampleTitle": "A friend produced {production}",
  "help.club.exampleEquationA11y": "{production} minus the first {threshold} equals {eligible} included in the calculation",
  "help.club.exampleEligible": "Only {eligible} enters the calculation",
  "help.club.exampleNearLabel": "If you invited them",
  "help.club.exampleFarLabel": "If your friend invited them",
  "help.club.exampleFormula": "{eligible} × {rate}",
  "help.club.exampleToYou": "credited to you",
  "help.club.exampleKeeps": "Your friend keeps all {production}. The club credits your reward separately",
  "help.club.countsTitle": "Counts as production",
  "help.club.countsBody": "Diamond taps and passive Faceting Circuit production",
  "help.club.excludesTitle": "Does not enter the calculation",
  "help.club.excludesBody": "PvP, tasks, achievements, club rewards, season payouts, and refunds",
  "help.club.noteV2": "Club rewards do not generate another {first} or {second} reward",
  "help.club.action": "Got it",
  "help.arena.title": "Arena",
  "help.arena.lead": "Masters compete in short games for carats in the Arena",
  "help.arena.rule1": "Choose a game and place its listed stake. Your opponent places the same amount",
  "help.arena.rule2": "The winner receives the shared pot. A draw or cancellation returns your stake",
  "help.arena.rule3": "If no live opponent is available, the Arena Guardian joins the match",
  "help.arena.rule4": "Each game has its own rules",
  "help.arena.note": "Open the rules from the game card before a match",
  "help.penalty.kicker": "Game rules",
  "help.penalty.lead": "In each series you take one shot and defend the goal once",
  "help.penalty.rule1": "Choose left, centre, or right. You have {turnSeconds} seconds to choose",
  "help.penalty.rule2": "The goalkeeper saves the ball by matching the shot direction",
  "help.penalty.rule3": "A tied score after three series starts deciding series. If the tie remains, the match ends in a draw",
  "help.penalty.stake": "Stake: {stake}. The winner receives {bank}; a draw returns your stake",
  "help.penalty.action": "Got it",
  "status.titleSelected": "“{name}” title selected",
  "status.dailyReward": "Daily reward claimed · {value}",
  "status.seasonTaskClaimed": "Season task reward claimed",
  "status.membershipChecked": "Membership confirmed",
  "status.membershipMissing": "Membership not found yet",
  "status.premiumPurchased": "Relic added to your workshop",
  "status.skinSelected": "Diamond skin changed",
  "status.achievementNamed": "“{name}” badge added to your collection",
  "status.achievement": "Living facet badge claimed",
  "status.reward": "Season reward claimed",
  "status.seasonInactive": "Production is paused. Open the season details",
  "status.actionUnavailable": "This action is not available yet",
  "status.previousTaskRequired": "Claim the previous reward in this task chain first",
  "status.taskNotComplete": "This task is not complete yet. Check its requirements and progress",
  "status.tapUnavailable": "Could not credit your taps. Contact support through your profile",
  "status.clubInviteCopied": "Invitation key copied",
  "status.clubInviteCopyFailed": "The link was not copied. Send it with the Share button",
  "status.clubInviteShared": "Invitation sent",
  "common.close": "Close",
  "common.skip": "Skip to game",
  "common.ready": "Ready",
  "common.on": "On",
  "common.off": "Off",
  "dev.title": "Review scenarios",
  "dev.firstEntry": "First entry",
  "dev.afterUpgrade": "After upgrade",
  "dev.insufficient": "Insufficient currency",
  "dev.network": "Network loss",
  "dev.partial": "Partially accepted taps",
  "dev.offline": "Offline production",
  "dev.projectionWarmup": "Projection warm-up",
  "dev.scheduled": "Season not started",
  "dev.scheduledWithClaim": "New season pending, reward claimable",
  "dev.frozen": "Season frozen",
  "dev.settling": "Season settlement",
  "dev.rewardReady": "Reward ready",
  "dev.rewardReceived": "Reward received",
  "dev.tonUsdtPrizeActive": "500 USDT prizes · active season",
  "dev.tonUsdtPrizeWinner": "200 USDT prize · winner",
  "dev.communityMissing": "Community membership missing",
  "dev.emptyFriends": "Empty friends",
  "dev.arenaReady": "Arena · ready to play",
  "dev.arenaResultStack": "Arena · result stack",
  "dev.activePvp": "Active match",
  "dev.largeBalance": "Balance · 17 million",
  "dev.visualStage3": "Diamond · stage 3",
  "dev.visualStage4": "Diamond · stage 4",
  "dev.energyEmpty": "Energy depleted",
  "dev.reduced": "Reduced motion",
  "dev.hide": "Hide scenarios",
  "hall.globalRewardReady": "Rewards ready: {count}",
  "hall.globalRewardPortal": "Trophy Hall · ready: {count}",
  "hall.mapRewardKicker": "Trophy Hall",
  "hall.mapRewardAction": "Claim rewards",
};

const dictionaries: Record<Locale, Dictionary> = { ru, en };

export type Translator = (key: TranslationKey, values?: Record<string, string | number>) => string;

export function createTranslator(locale: Locale): Translator {
  return (key, values = {}) => {
    let value = dictionaries[locale][key];
    for (const [name, replacement] of Object.entries(values)) {
      value = value.replaceAll(`{${name}}`, String(replacement));
    }
    return value;
  };
}
